import React from "react";
import UpCareProduct from "./Forms/UpCare";
import FlexPrivateProduct from "./Forms/FlexPrivate";
import FlexProProduct from "./Forms/FlexPro";
import LeasePlusProduct from "./Forms/LeasePlus";
import Information from "../component/Information";
import { AuthContext } from "../auth/hcsauthprovider";
import axios from "axios";
import AccessoriesConstruction from "../component/Accessories";
import { sendOrder } from "../component/sendOrder";
import { GeneratePrivacyNoticePdf } from "../component/PrivacyNotice/GeneratePrivacyNoticePDF";
import PaymentSelection from "../component/Adyen/PaymentInformation";
import InvoiceUploader from "../component/Information/Customer/InvoiceChecker";
import { GenerateSignaturePDF } from "../component/TransferAgreement/GenerateSignaturePDF";
import {
  calculateTotalFee,
  calculatePriceInstallationModified,
} from "../logic/Calculations";
import { useParams } from "react-router-dom";
import DisplayField from "../component/Fields/DisplayField";
import debounce from "lodash.debounce";
import CreditCheck from "../component/CreditCheck/CreditCheck";
import CreatePreContractUk from "../component/Contract/CreatePreContractUk";
import CreateContractUk from "../component/Contract/CreateContractUk";
import CreateContract from "../component/Contract/CreateContract";
import DisplayContract from "../component/Contract/DisplayContract";
import FormRes from "../component/FormRes/FormRes";
import CircularProgress from "@mui/material/CircularProgress";
import InvoiceModal from "../component/Information/Customer/InvoiceModal";
import {
  getCountryInformationDB,
  getCountryInformation,
  getDefaultPrices,
  verifiedRequest,
  getContractPDF,
  getDefaultPricesAccessories,
  getAccessories,
  getContractNumber,
  uploadInvoiceForChecking,
  getDefaultPricesGlobalAccessories,
  createOrder,
  createAdyen,
  uploadDocuments,
  sendInvoiceEmail,
  getProducts,
  getUpCareProducts,
} from "../logic/ServerCalls";
import { PDFDocument } from "pdf-lib";
import {
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Tooltip,
  TextField,
  Divider,
  FormHelperText,
  Typography,
  Box,
  Modal,
  darken,
  Link,
  Grid,
} from "@mui/material";

import InputNumber from "../component/Fields/InputNumber";
import InputText from "../component/Fields/InputText";
import CustomerInformationBusiness from "../component/Information/Customer/Business";
import CustomerInformationPrivate from "../component/Information/Customer/Private";
import CustomerInformationIdentification from "../component/Information/Customer/Identification";
import QuoteCustomerInformation from "../component/Information/Customer/QuoteInformation";
import FillBySSN from "../component/Information/Customer/FillBySSN";
import DealerInformation from "../component/Information/Dealer/DealerInformation";
import NewDealer from "../component/Information/Dealer/NewDealer";
import Header from "../component/Header";
import ConfidentialityNotice from "../component/ConfidentialityNotice";

import ConstructionProduct from "./Forms/Construction";
import NotFound from "../component/NotFound";
import configSource from "../res/config.json";
import config from "./res/config.json";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import LoginIcon from "@mui/icons-material/Login";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import StepperComponent from "../component/StepperComponent";
import "./css/Hcs.css";
import TransferAgreement from "../component/TransferAgreement/TransferAgreement";
import CreateTransferAgreement from "../component/TransferAgreement/CreateTransferAgreement";
import { generateOrderPDF } from "../component/sendOrder";
import {
  blobToBase64,
  downloadPDF,
  roundTotalMonthlyFeeByCountry,
} from "../logic/GeneralFunctions";
import { GenerateFacturePDF } from "../component/Facture/GenerateFacturePDF";
import CreateHireAgreement from "../component/HireAgreement/CreateHireAgreement";
import { sendHireAgreementEmail } from "../logic/ServerCalls";
import { validateEmail } from "../logic/Validator";
import {
  ADYEN_ERROR_TYPES,
  getAdyenErrorMessage,
} from "../component/Adyen/AdyenPopupMessage";
import CompanyType from "../component/Information/Customer/ComapnyType";

const ReactDomServer = require("react-dom/server");

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

const socialSecurityNumberCountries = ["se", "dk", "no", "fi"];
const repurchaseMultiplier = new Date().getFullYear() === 2025 ? 1 : 0.8824; //price change needs to be applied 01.01.2026, this ternary can be removed in 2026
const adyenCountriesMap = {
  leaseplus: ["fr", "de", "uk"],
  upcare: ["uk", "se", "jp", "no"],
};
const CEORA_CAMPAIGN_PASSWORD = "2026Q4";

const products_with_0_discount = [
  "970800812",
  "970745512",
  "970844001",
  "970468201",
  "970800803",
  "970745503",
  "970844003",
  "970468203",
  "970800821",
  "970745521",
  "970891301",
  "970891401",
  "970891501",
  "970891601", // --
  "587932901",
  "547121701",
  "967152301",
  "967648901",
  "967649001",
  "970626201",
  "970745701",
  "970727001",
  "967649101",
  "970626301",
  "970727101",
  "967978301",
  "967978501",
  "967978401",
  "967978601",
  "970727201",
  "970612001",
  "967985601",
  "536900001",
  "547115401",
  "547115402",
  "547121501",
  "547121502",
  "596867501",
  "970745601",
  "970745602",
  "536902701",
  "590450001",
  "596288701",
  "596289201",
  "596290101",
  "596290001",
  "592755101",
  "546486101",
  "966968401",
  "967985201",
  "970601601",
  "970601602",
  "970601501",
  "970601701",
  "970601702",
  "967985401",
  "967985301",
  "967985503",
  "970544901",
  "967648401",
  "536900201",
  "966415901",
  "966833001",
  "592755201",
  "592755301",
  "536903001",
  "596293001",
  "597750801",
  "970640901",
];

const products_with_10_discount = [
  "970749901", //546 EPOS
  "970549001", //544 EPOS
  "970614401", // RZ 43L
  "970468001", // RZ 43M
  "970468101", // CS4
  "970468103", // CS4 UK
  // "970468201", // RS5 ref station
  // "970468203", // RS5 UK for ref station
];

class Hcs extends React.Component {
  state = {
    color: "#800080",
    img: "",
    accFailed: [],
    labels: {},
    allLabels: {},
    variables: {},
    baseVariables: {},
    usedVariables: {},
    products: {},
    headerText: "",
    headerImgSrc: "",
    params: {},
    beLanguage: "fr",
    modalOpen: false,
    openPopup: false,
    openPopupDocs: false,
    openPopupAdyen: false,
    popupMessage: "",
    popupHeaderMessage: "",
    productsValues: {
      product1: {
        deliveryDate: null,
        productList: "productList1",
        name: null,
        quantity: 1,
        serial: [],
        price: 0,
        service: 0,
        purchasePrice: 0,
        installation: 0,
        residual: 10,
        residualPrice: 0,
        accessory: [null],
        accessoryPrice: [0],
        purchasePriceAccessory: [0],
        installationAccessory: [0],
        residualPriceAccessory: [0],
        residualPriceAccessorySum: 0,
        purchasePriceAccessorySum: 0,
        installationAccessorySum: 0,
        upCare: false,
        firstIncresedRent: 0,
        totalProductPrice: 0,
        finished: false,
        ownServiceIncludes: {
          storage: false,
          consumables: false,
          education: false,
          maintenance: false,
          repairs: true,
          other: false,
          noService: false,
        },
        manuallyModified: {
          installationModified: false,
        },
      },
    },
    accessories: {},
    customerInformation: {
      privateFinished: false,
      businessFinished: false,
      companyTypeFinished: false,
      requiresExtraFile: false,
      businessExtraFiles: [],
      quoteInformationFinished: false,
      identificationFinished: false,
      dealerFinished: false,
      dealerName: "",
      dealerEmail: "",
      dealerPhone: "",
      dealerAdress: "",
      dealerZipCode: "",
      dealerCity: "",
      customerFirstName: "",
      customerLastName: "",
      customerStreet: "",
      customerHouseNumber: "",
      customerEmail: "",
      customerInvoiceEmail: "",
      customerGeneralContact: "",
      customerPhone: "",
      customerNumber: "",
      customerCity: "",
      customerZipCode: "",
      companyRegNumber: "",
      companyType: "",
      companyTypeKey: "",
      idType: "",
      idNumber: "",
      pep: "",
      repurchase: "",
      repurchaseKey: "",
      dateOfBirth: null,
      socialSecurityNumber: "",
      address: "",
      zipCode: "",
      city: "",
      signatories: {
        signatory1: {
          nameSignatory: "",
          emailSignatory: "",
          phoneSignatory: "",
          socialSecurityNumberCustomerSignatory: "",
          dateOfBirthCustomerSignatory: null,
          idTypeSignatory: "",
          idNumberSignatory: "",
          pepSignatory: "",
        },
      },
      customerDeliveryStreet: "",
      customerDeliveryHouseNumber: "",
      deliveryZipCode: "",
      deliveryCity: "",
    },
    formInformation: {
      customContractNumber: "",
      productCondition: "new",
      lifeOffer: "firstLife",
      totalMonthlyFee: 0,
      totalPrice: 0,
      totalResidue: 0,
      totalAccessoriesPrice: 0,
      amortization: 0,
      formState: "edit",
      showInvalid: false,
      quoteChecked: false,
      orderChecked: false,
      newDealerChecked: false,
      newDealerNotChecked: false,
      limitedCompanyChecked: false,
      limitedCompanyNotChecked: false,
      idChecked: false,
      peppol: false,
      legalSignatoryChecked: false,
      ampChecked: false,
      ceoraCampaign: true,
      isCeoraForm: true,
      contractLength: 36,
      contractLengths: [36],
      customer: "Private",
      useCampaign: false,
      extraInfo: "",
      contractNumber: "",
      fillBySSN: false,
      directDebit: false,
    },
    newDealerInformation: {
      newDealerFinished: false,
      verifyNewDealer: false,
      newDealerName: "",
      taxNumber: "",
      organizationNumber: "",
      husqvarnaNumber: "",
      fcaNumber: "",
      dealerAddress: "",
      nd_zipCode: "",
      nd_city: "",
      invoiceEmail: "",
      contactPerson: "",
      emailContactPerson: "",
      phoneContactPerson: "",
      bankName: "",
      ibanNumber: "",
      bicSwiftCode: "",
      bankNumber: "",
      sortCode: "",
      registrationNumber: "",
      newDealerSignatories: {
        newDealerSignatory1: {
          nameSignatoryNewDealer: undefined,
          emailSignatoryNewDealer: undefined,
          dateOfBirthSignatory: null,
          socialSecurityNumberSignatory: undefined,
        },
      },
    },
    creditInfo: {
      score: null,
    },
    preContractFile: {
      file: null,
      fileName: "PreContract_Lease_Plus.pdf",
      fileDisplay: null,
      fileSize: null,
    },
    contractFile: {
      file: null,
      fileName: "Hyreskontrakt_Lease_Plus.pdf",
      fileDisplay: null,
      fileSize: null,
    },
    transferAgreementFile: {
      file: null,
      fileName: "",
      fileDisplay: null,
      fileSize: null,
    },
    creditFile: {
      file: null,
      fileName: "credit.pdf",
      fileSize: null,
    },
    hireAgreementFile: {
      file: null,
      fileName: "",
      fileSize: null,
    },
    factureFictive: {
      file: null,
      fileName: "",
      fileSize: null,
    },
    campaign: false,
    extraFiles: [],
    firstRender: true,
    isVerified: false,
    showAdminLogin: false,
    passwordInput: "",
    stepLabels: [],
    stepCounter: 0,
    isLoading: false,
    invoiceDidNotMatch: false,
    paymentId: "",
    invoiceDidNotMatchModalOpen: false,
    accessoriesVisible: false,
    accessorySinglePrice: 0,
    accessorySingleResidual: 0,
    accesoryLocation: "",
    hireAgreementPdfPromise: null,
    contractPdfPromise: null,
  };

  static contextType = AuthContext;
  /**
   *  Gets called after first render.
   */
  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    if (this.context.isAuthenticated()) {
      this.setState({ isVerified: true });
    }
    if (this.validateParams()) {
      this.setState({
        firstRender: false,
        color: "#800080",
        img: "/husqvarna_logo.png",
        params: { ...this.props.params, comp: "hcs", isCeoraForm: true },
      });
      this.SetFormInformation();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  handleBeforeUnload = (event) => {
    if (this.state.formInformation.formState === "completed") {
      return;
    }

    event.preventDefault();
    event.returnValue = "";
  };

  setStateAsync(stateUpdate) {
    return new Promise((resolve) => {
      this.setState(stateUpdate, resolve);
    });
  }

  handleInvoiceModalClose = async (matched) => {
    this.setState({ invoiceDidNotMatchModalOpen: false });

    if (matched) {
      this.switchFormState("review");
    }
  };

  /**
   * Requests labels, headerText, productlist and variables from server and puts them in state.
   */
  SetFormInformation = () => {
    (async () => {
      try {
        const comp = "hcs";
        const lang = this.props.params.lang.toLowerCase();
        const formType = this.props.params.formType.toLowerCase();
        let data = await getCountryInformationDB(comp, lang, formType);
        const regex = /^step\d+$/;

        let state = this.state;
        if (
          formType === "upcare" ||
          formType === "flexpro" ||
          formType === "construction" ||
          formType === "standard"
        ) {
          state.formInformation.customer = "Business";
        } else {
          state.formInformation.customer = "Private";
        }
        let labels = {};
        for (const label of data.labelsResponse.data) {
          // Some labels (e.g. id_select, pep) are stored as arrays in DB, parse them back.
          try {
            const parsed = JSON.parse(label.value);
            labels[label.Field.name] = Array.isArray(parsed)
              ? parsed
              : label.value;
          } catch {
            labels[label.Field.name] = label.value;
          }
        }

        state.labels = labels;

        let i = 1;
        const sortedSteps = [];

        while (labels.hasOwnProperty(`step${i}`)) {
          if (regex.test(`step${i}`)) {
            sortedSteps.push(labels[`step${i}`]);
          }
          i++;
        }

        if (formType === "upcare" && lang === "uk") {
          state.stepLabels = sortedSteps.filter(
            (_, index) => index !== 2 && index !== 4 && index !== 5,
          );
        } else if (formType === "upcare" && lang === "se") {
          state.stepLabels = sortedSteps.filter(
            (_, index) => index !== 2 && index !== 4,
          );
        } else if (formType === "leaseplus" && lang === "se") {
          state.stepLabels = sortedSteps.filter((_, index) => index !== 3);
        } else {
          state.stepLabels = sortedSteps;
        }

        let tooltips = {};
        for (const tooltip of data.tooltipsResponse.data) {
          tooltips[tooltip.Field.name] = tooltip.value;
        }
        state.tooltips = tooltips;

        let variables = {};
        let usedVariables = {};

        for (const values of data.variableResponse.data.Variables) {
          const name = values.name;
          const value = values.CountryVariable.value;
          if (name.startsWith("used_")) {
            usedVariables[name.replace("used_", "")] = value;
          } else {
            variables[name] = value;
          }
        }
        /*Variables are fetched per country only, no formType support on the backend yet.
          Upcare-specific overrides are hardcoded here as a workaround.
          TODO: add formType support to backend variables so this can be removed.*/

        const functionInterestMap = {
          upcare: {
            uk: 11.46,
            se: 9.6,
          },
        };
        const functionInterestOverride = functionInterestMap[formType]?.[lang];
        if (functionInterestOverride) {
          variables.function_interest = functionInterestOverride;
        }
        state.baseVariables = { ...variables };
        state.variables = { ...variables };
        state.usedVariables = usedVariables;
        if (formType === "upcare") {
          state.products = await getUpCareProducts(lang, 60, "ceora_campaign");
        } else {
          let products = [];
          for (const product of data.productsResponse.data) {
            products.push(product.name);
          }
          state.products = products;
        }

        if (formType === "leaseplus") {
          if (data.accessoriesResponse.data.length > 0) {
            let accessories = [];
            for (const accessory of data.accessoriesResponse.data) {
              accessories.push(accessory.name);
            }
            state.accessories = accessories;
          } else {
            state.accessories = [];
          }
        }

        let headertext = {
          text: data.headerTextResponse.data.text,
          campaign: data.headerTextResponse.data.campaign,
        };
        state.headerText = headertext;
        state.campaign = false;
        state.formInformation.contractLengths = [60];
        state.formInformation.contractLength = 60;
        try {
          let response = await fetch(
            configSource.ROOT +
              `getimage?company=hcs&country=images&type=Logo.jpg`,
          );
          state.headerImgSrc = response.url;
        } catch (error) {
          console.log("Could Not Fetch Header Image: \n", error);
        }
        this.setState(state);
      } catch (error) {
        //TODO redirect
        console.log(error);
      }
    })();
  };

  /**
   * Passes values to function and sets state with result
   */
  newCalculationsProductFee = debounce(() => {
    const result = calculateTotalFee(
      this.state.productsValues,
      this.state.formInformation.contractLength,
      this.state.variables,
      this.state.accessories,
      this.state.params.formType.toLowerCase(),
    );
    if (this.state.formInformation.ceoraCampaign) {
      let discount = 1;
      let productList;
      if (this.state.formInformation.contractLength === 36) {
        productList = this.state.products.productList1;
      } else if (this.state.formInformation.contractLength === 48) {
        productList = this.state.products.productList2;
      } else if (this.state.formInformation.contractLength === 60) {
        productList = this.state.products.productList3;
      } else {
        productList = this.state.products.productList1;
      }
      for (const [, value] of Object.entries(this.state.productsValues)) {
        if (productList[value.name]?.campaign <= 1) {
          if (productList[value.name]?.campaign > discount) {
            discount = productList[value.name]?.campaign;
          } else if (discount === 1) {
            discount = productList[value.name]?.campaign;
          }
        }
      }
      result.totalMonthlyFee = result.totalMonthlyFee * discount;
    }
    let formInformation = this.state.formInformation;
    Object.assign(formInformation, result);
    this.setState({ formInformation: formInformation });
  }, 500);

  /**
   *
   * @param {Object} value - Updated product information
   * @param {String} id    - Product id
   *
   * Updates given product with information from value
   */
  updateProduct = (value, id) => {
    let productsValues = this.state.productsValues;
    let variables = this.state.variables;
    for (let key in value) {
      productsValues[id][key] =
        key === "ownServiceIncludes"
          ? Object.assign(productsValues[id][key], value[key])
          : (productsValues[id][key] = value[key]);
      if (key === "name") {
        productsValues[id].manuallyModified.installationModified = false;
      }
      if (key === "installation") {
        productsValues[id].manuallyModified.installationModified = true;
      }
    }
    this.setState({
      productsValues: productsValues,
    });
    if ("interest" in value) {
      variables["function_interest"] = value["interest"];
      this.setState({
        variables: variables,
      });
    }
  };

  /**
   * Used by LeasePlus and UpCare.
   * Calculates total monthly fee. Updates price, totalProductPrice and totalMonthlyFee.
   */
  updateTotalMonthlyFee = async () => {
    let formInformation = this.state.formInformation;
    let totalMonthlyFee = 0;
    let discount = 1;
    let failedAccessories = [];
    for (const productId in this.state.productsValues) {
      const nrOfAccessories =
        this.state.productsValues[productId].accessory.length;
      let product = this.state.productsValues[productId];
      let data = {};
      let price = 0;
      let residual = 0;
      let accessoryPrice = new Array(nrOfAccessories).fill(0);
      let purchasePrice = 0;
      let residualPrice = 0;
      let installation = 0;
      let purchasePriceAccessory = new Array(nrOfAccessories).fill(0);
      let residualPriceAccessory = new Array(nrOfAccessories).fill(0);
      let installationAccessory = new Array(nrOfAccessories).fill(0);
      let discount5 = 0.95;
      let discount10 = 0.9;

      // Death code
      // if (this.state.formInformation.ceoraCampaign) {
      //   let campaign =
      //     this.state.products[this.state.productsValues[productId].productList][
      //       product.name
      //     ]?.campaign;
      //   if (campaign > discount || discount === 1) {
      //     discount = campaign;
      //   }
      // }
      if (product.name !== null) {
        if (product.name === this.state.labels.accessory) {
          function applyMinimalPrice(price, countryCode) {
            const MIN_PRICE_BY_COUNTRY = {
              fr: 3,
              se: 30,
              no: 30,
            };

            const minPrice = MIN_PRICE_BY_COUNTRY[countryCode] ?? 0;

            return price < minPrice ? minPrice : price;
          }

          price = applyMinimalPrice(
            this.state.productsValues[this.state.accesoryLocation].price,
            this.state.params.lang.toLowerCase(),
          );
          residualPrice =
            this.state.productsValues[this.state.accesoryLocation]
              .residualPrice;
          purchasePrice =
            this.state.productsValues[this.state.accesoryLocation]
              .purchasePrice;
        } else {
          const defaultPrices = await getDefaultPrices(
            this.state.params.lang.toLowerCase(),
            "ceora_campaign",
            product.name,
            this.state.formInformation.contractLength,
          );
          price = defaultPrices?.DefaultProductValue.monthlyFee;
          installation =
            defaultPrices?.DefaultProductValue.ServicePrices[0].price;
          residualPrice = defaultPrices?.DefaultProductValue.residual;
          purchasePrice =
            this.state.params.formType.toLowerCase() === "leaseplus" &&
            this.state.customerInformation.repurchase !==
              this.state.labels.dealer_repurchase
              ? defaultPrices?.DefaultProductValue.price * repurchaseMultiplier
              : defaultPrices?.DefaultProductValue.price;

          if (product.manuallyModified?.installationModified) {
            price = calculatePriceInstallationModified(
              installation,
              product.installation,
              price,
              this.state.formInformation.contractLength,
              this.state.variables,
            );
            installation = product.installation;
          }
        }
      }

      for (const accessoryIndex in this.state.productsValues[productId]
        .accessory) {
        const accessory =
          this.state.productsValues[productId].accessory[accessoryIndex];
        if (accessory !== null) {
          let productName = "";
          if (product.name === null) {
            for (let productTest of this.state.products) {
              const accessories = await getAccessories(
                this.props.params.lang.toLowerCase(),
                this.props.params.formType.toLowerCase(),
                this.state.formInformation.contractLength,
                productTest,
              );
              const accessoryArray = accessories.map((object) => object.name);
              if (accessoryArray.includes(accessory)) {
                productName = productTest;
                break;
              }
            }
          } else {
            productName = product.name;
          }

          let defaultPricesAccessories = await getDefaultPricesAccessories(
            this.state.params.lang.toLowerCase(),
            this.state.params.formType.toLowerCase(),
            productName,
            this.state.formInformation.contractLength,
            accessory,
          );

          if (!defaultPricesAccessories && this.props.params.lang === "fr") {
            // Consider whether this applies to other languages !
            defaultPricesAccessories = await getDefaultPricesGlobalAccessories(
              this.state.productsValues[productId],
              this.state.params.lang.toLowerCase(),
              this.state.params.formType.toLowerCase(),
              this.state.formInformation.contractLength,
              accessory,
            );
          }
          if (
            defaultPricesAccessories &&
            defaultPricesAccessories.accesssoryNotFound
          ) {
            failedAccessories.push(accessory);
          }

          if (
            defaultPricesAccessories &&
            !defaultPricesAccessories.accesssoryNotFound
          ) {
            accessoryPrice[accessoryIndex] +=
              defaultPricesAccessories?.DefaultProductValue.monthlyFee;
            installationAccessory[accessoryIndex] +=
              defaultPricesAccessories?.DefaultProductValue.ServicePrices[0].price;
            residualPriceAccessory[accessoryIndex] +=
              defaultPricesAccessories?.DefaultProductValue.residual;
            purchasePriceAccessory[accessoryIndex] +=
              defaultPricesAccessories?.DefaultProductValue.price;
          }
        }
      }

      const accessoryPriceSum = accessoryPrice.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      );
      const installationAccessorySum = installationAccessory.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      );
      const residualPriceAccessorySum = residualPriceAccessory.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      );
      const purchasePriceAccessorySum = purchasePriceAccessory.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
      );
      let totalProductPrice = price * product.quantity + accessoryPriceSum;
      let productNumber = product.name ? product.name.split(" ")[0] : null;

      if (
        this.state.formInformation.ceoraCampaign &&
        products_with_0_discount.includes(productNumber)
      ) {
        console.log("regular price", totalProductPrice);
      } else if (
        this.state.formInformation.ceoraCampaign &&
        products_with_10_discount.includes(productNumber)
      ) {
        console.log(
          "10% discount",
          totalProductPrice,
          "=>",
          totalProductPrice * discount10,
        );
        totalProductPrice = totalProductPrice * discount10;
      } else {
        console.log(
          "5% discount",
          totalProductPrice,
          "=>",
          totalProductPrice * discount5,
        );
        totalProductPrice = totalProductPrice * discount5;
      }

      data["residualPrice"] = residualPrice;
      data["purchasePrice"] = purchasePrice;
      data["installation"] = installation;
      data["residualPriceAccessory"] = residualPriceAccessory;
      data["purchasePriceAccessory"] = purchasePriceAccessory;
      data["installationAccessory"] = installationAccessory;
      data["residualPriceAccessorySum"] = residualPriceAccessorySum;
      data["purchasePriceAccessorySum"] = purchasePriceAccessorySum;
      data["installationAccessorySum"] = installationAccessorySum;
      data["price"] = price;
      data["totalProductPrice"] = totalProductPrice;
      data["residual"] = residual;
      data["accessoryPrice"] = accessoryPrice;
      totalMonthlyFee += totalProductPrice;
      this.updateProduct(data, productId);
    }
    let accessoryPriceExtra = 0;
    let annuityAccessory = 0;
    if (Object.keys(this.state.accessories).length > 0) {
      let accessories = this.state.accessories;
      Object.keys(this.state.accessories).forEach((accessory) => {
        if (accessories[accessory].TotalAccessoriesPrice !== undefined) {
          accessoryPriceExtra += accessories[accessory]?.TotalAccessoriesPrice;
        }
      });
      let t =
        (1 + this.state.variables.function_interest / 1200) **
        this.state.formInformation.contractLength;
      annuityAccessory =
        (accessoryPriceExtra *
          t *
          (this.state.variables.function_interest / 1200)) /
        ((1 +
          (this.state.variables.function_interest / 1200) *
            this.state.variables.payment) *
          (t - 1));
      accessoryPriceExtra = annuityAccessory;
    }
    totalMonthlyFee += accessoryPriceExtra;
    // Death code
    // if (this.state.formInformation.ceoraCampaign) {
    //   totalMonthlyFee = totalMonthlyFee * discount;
    // }
    formInformation.totalMonthlyFee = totalMonthlyFee;
    this.setState({
      formInformation: formInformation,
      accFailed: failedAccessories,
    });
  };

  /**
   *
   * @param {Array<File>} files
   *
   * Puts the files in the array in state.
   */
  addExtraFiles = (files) => {
    let extraFiles = this.state.extraFiles;
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      extraFiles.push(element);
    }
    this.setState({ extraFiles: extraFiles });
  };

  /**
   *
   * @param {File} file
   *
   * Removes given file from state if it exists.
   */
  removeExtraFiles = (file) => {
    let extraFiles = this.state.extraFiles;
    let index = extraFiles.indexOf(file);
    if (index !== -1) {
      extraFiles.splice(index, 1);
    }
    this.setState({ extraFiles: extraFiles });
  };

  /**
   *
   * Adds new object in productsValues with newId.
   * newId = highest oldId + 1.
   * Also populates the new product objects with deafult values.
   */
  addAnotherProduct = () => {
    const newId = Object.keys(this.state.productsValues).length + 1;

    const key = "product" + newId;

    let productsValues = this.state.productsValues;
    productsValues[key] = {};
    productsValues[key]["deliveryDate"] = null;
    productsValues[key]["productList"] = "productList1";
    productsValues[key]["name"] = null;
    productsValues[key]["quantity"] = 1;
    productsValues[key]["serial"] = [];
    productsValues[key]["price"] = 0;
    productsValues[key]["accessory"] = [null];
    productsValues[key]["accessoryPrice"] = [0];
    productsValues[key]["service"] = 0;
    productsValues[key]["purchasePrice"] = 0;
    productsValues[key]["residualPrice"] = 0;
    productsValues[key]["installation"] = 0;
    productsValues[key]["residual"] = 10;
    productsValues[key]["upCare"] = false;
    productsValues[key]["firstIncresedRent"] = 0;
    productsValues[key]["totalProductPrice"] = 0;
    productsValues[key]["finished"] = false;
    productsValues[key]["purchasePriceAccessory"] = [0];
    productsValues[key]["installationAccessory"] = [0];
    productsValues[key]["residualPriceAccessory"] = [0];
    productsValues[key]["residualPriceAccessorySum"] = 0;
    productsValues[key]["purchasePriceAccessorySum"] = 0;
    productsValues[key]["installationAccessorySum"] = 0;
    productsValues[key]["ownServiceIncludes"] = {
      storage: false,
      consumables: false,
      education: false,
      maintenance: false,
      repairs: true,
      other: false,
    };
    productsValues[key]["manuallyModified"] = {
      installationModified: false,
    };

    this.setState({
      productsValues: productsValues,
    });
  };

  getAccessoryResidualPrice = (countryCode) => {
    const map = {
      fr: 1,
      se: 10,
      no: 10,
      de: 1,
      uk: 1,
    };

    return map[countryCode] ?? 10;
  };

  addAccessoryProduct = (id) => {
    const key = "product" + id;

    let productsValues = this.state.productsValues;
    productsValues[key] = {};
    productsValues[key]["deliveryDate"] = null;
    productsValues[key]["productList"] = "productList1";
    productsValues[key]["name"] = this.state.labels.accessory;
    productsValues[key]["quantity"] = 1;
    productsValues[key]["serial"] = [];
    productsValues[key]["price"] = 0;
    productsValues[key]["accessory"] = [null];
    productsValues[key]["accessoryPrice"] = [0];
    productsValues[key]["service"] = 0;
    productsValues[key]["purchasePrice"] = 0;
    productsValues[key]["residualPrice"] = 0;
    productsValues[key]["installation"] = 0;
    productsValues[key]["residual"] = 10;
    productsValues[key]["upCare"] = false;
    productsValues[key]["firstIncresedRent"] = 0;
    productsValues[key]["totalProductPrice"] = 0;
    productsValues[key]["finished"] = true;
    productsValues[key]["purchasePriceAccessory"] = [0];
    productsValues[key]["installationAccessory"] = [0];
    productsValues[key]["residualPriceAccessory"] = [0];
    productsValues[key]["residualPriceAccessorySum"] = 0;
    productsValues[key]["purchasePriceAccessorySum"] = 0;
    productsValues[key]["installationAccessorySum"] = 0;
    productsValues[key]["ownServiceIncludes"] = {
      storage: false,
      consumables: false,
      education: false,
      maintenance: false,
      repairs: true,
      other: false,
    };
    productsValues[key]["manuallyModified"] = {
      installationModified: false,
    };

    this.setState({
      productsValues: productsValues,
    });
  };

  /**
   * Adds a new leaseplus accessory
   */
  addLeasePlusAccessory = (productId) => {
    let productsValues = this.state.productsValues;
    productsValues[productId].accessory.push(null);
    productsValues[productId].purchasePriceAccessory.push(0);
    productsValues[productId].accessoryPrice.push(0);
    productsValues[productId].installationAccessory.push(0);
    productsValues[productId].residualPriceAccessory.push(0);
    this.setState({
      productsValues: productsValues,
    });
  };

  /**
   * Removes last leaseplus accessory.
   */
  removeLeasePlusAccessory = (productId) => {
    let productsValues = this.state.productsValues;
    productsValues[productId].accessory.pop();
    productsValues[productId].purchasePriceAccessory.pop();
    productsValues[productId].accessoryPrice.pop();
    productsValues[productId].installationAccessory.pop();
    productsValues[productId].residualPriceAccessory.pop();
    this.setState({
      productsValues: productsValues,
    });
    this.updateTotalMonthlyFee();
  };

  /**
   *
   * Removes the last product from state if there are more than one
   * and updates totalMonthlyFee in state.
   */
  removeProduct = () => {
    let productsValues = this.state.productsValues;
    const id = Object.keys(productsValues).at(-1);
    if (productsValues[id].name === this.state.labels.accessory) {
      this.removeAccessoryProduct(id);
    }
    delete productsValues[id];
    this.setState({
      productsValues: productsValues,
    });
    if (
      this.state.params.formType.toLowerCase() === "upcare" ||
      this.state.params.formType.toLowerCase() === "leaseplus"
    ) {
      this.updateTotalMonthlyFee();
    } else {
      this.newCalculationsProductFee();
    }
  };

  removeAccessoryProduct = (id) => {
    let productsValues = this.state.productsValues;
    let state = this.state;
    state.accessorySingleResidual = 0;
    state.accessorySinglePrice = 0;
    state.accesoryLocation = "";
    state.accessoriesVisible = false;

    this.setState(state);
    delete productsValues[id];
    this.setState({
      productsValues: productsValues,
    });
    if (
      this.state.params.formType.toLowerCase() === "upcare" ||
      this.state.params.formType.toLowerCase() === "leaseplus"
    ) {
      this.updateTotalMonthlyFee();
    } else {
      this.newCalculationsProductFee();
    }
  };
  addAccessories = () => {
    const key = Object.keys(this.state.accessories).length + 1;
    const id = "accessories" + key;
    let accessories = this.state.accessories;
    accessories[id] = { AccessoriesQuantity: 1 };
    this.setState({
      accessories: accessories,
    });
  };
  /**
   * Adds a new Object to accessories.
   */

  addGroupAccessories = () => {
    const key = Object.keys(this.state.accessories).length + 1;
    const id = "accessories" + key;
    let accessories = this.state.accessories;
    accessories[id] = { AccessoriesQuantity: 1 };
    this.setState({
      accessories: accessories,
    });
  };

  /**
   * Removes last object from accessories.
   */
  removeAccessories = () => {
    const id = Object.keys(this.state.accessories).at(-1);
    let accessories = this.state.accessories;
    delete accessories[id];
    this.setState({
      accessories: accessories,
    });
    if (
      this.state.params.formType.toLowerCase() === "upcare" ||
      this.state.params.formType.toLowerCase() === "leaseplus"
    ) {
      this.updateTotalMonthlyFee();
    } else {
      this.newCalculationsProductFee();
    }
  };

  /**
   * Adds a new object to signatories.
   */
  addSignatory = (newDealer) => {
    if (newDealer) {
      const key =
        Object.keys(this.state.newDealerInformation.newDealerSignatories)
          .length + 1;
      const id = "newDealerSignatory" + key;
      let signatories = this.state.newDealerInformation.newDealerSignatories;
      signatories[id] = {
        nameSignatoryNewDealer: "",
        emailSignatoryNewDealer: "",
        dateOfBirthSignatory: null,
        socialSecurityNumberSignatory: "",
      };
      this.setState({
        newDealerSignatories: signatories,
      });
    } else {
      const key =
        Object.keys(this.state.customerInformation.signatories).length + 1;
      const id = "signatory" + key;
      let signatories = this.state.customerInformation.signatories;
      signatories[id] = {
        nameSignatory: "",
        emailSignatory: "",
        phoneSignatory: "",
        socialSecurityNumberCustomerSignatory: "",
        dateOfBirthCustomerSignatory: null,
        idTypeSignatory: this.state.labels.id_select[0],
        idNumberSignatory: "",
        pepSignatory: this.state.labels.pep[0],
      };
      this.setState({
        signatories: signatories,
      });
    }
  };

  /**
   * Remove last object from signatories.
   */
  removeSignatory = (newDealer) => {
    if (newDealer) {
      const id = Object.keys(
        this.state.newDealerInformation.newDealerSignatories,
      ).at(-1);
      let signatories = this.state.newDealerInformation.newDealerSignatories;
      delete signatories[id];
      this.setState({
        newDealerSignatories: signatories,
      });
    } else {
      const id = Object.keys(this.state.customerInformation.signatories).at(-1);
      let signatories = this.state.customerInformation.signatories;
      delete signatories[id];
      this.setState({
        signatories: signatories,
      });
    }
  };

  generateAccessories = (id) => {
    return (
      <AccessoriesConstruction
        id={id}
        key={id}
        labels={this.state.labels}
        handleAccessories={this.handleAccessories}
        accessories={this.state.accessories[id]}
        number={id.charAt(id.length - 1)}
      />
    );
  };

  /**
   *
   * @param {Object} info
   *
   * Updates the value of customerInformation based on keys in info.
   */
  handleCustomerInfoChange = (info) => {
    let customerInformation = this.state.customerInformation;
    for (let id in info) {
      customerInformation[id] = info[id];
    }
    this.setState({
      customerInformation: customerInformation,
    });
  };

  //THIS IS USED ONLY FOR CUTOMER DELIVERY ADDRESS(fr/leaseplus)
  handleCustomerDeliveryInfoChange = (info) => {
    let customerInformation = this.state.customerInformation;
    for (let id in info) {
      switch (id) {
        case "customerHouseNumber":
          customerInformation.customerDeliveryHouseNumber = info[id];
          break;
        case "customerStreet":
          customerInformation.customerDeliveryStreet = info[id];
          break;
        case "customerZipCode":
          customerInformation.deliveryZipCode = info[id];
          break;
        case "customerCity":
          customerInformation.deliveryCity = info[id];
          break;
        default:
          customerInformation[id] = info[id];
      }
    }
    this.setState({
      customerInformation: customerInformation,
    });
  };

  /**
   *
   * @param {Object} info
   *
   * Updates the value of newDealerInformation based on keys in info.
   */
  handleNewDealerInfoChange = (info) => {
    let newDealerInformation = this.state.newDealerInformation;
    for (let id in info) {
      newDealerInformation[id] = info[id];
    }
    this.setState({
      newDealerInformation: newDealerInformation,
    });
  };

  /**
   *
   * @param {Object} value
   * @param {String} id
   *
   * Updates the value of the accessory with key id with the new value.
   */
  handleAccessories = (value, id) => {
    let accessories = this.state.accessories;

    Object.entries(value).forEach(([key, val]) => {
      accessories[id][key] = val;
    });
    this.setState({ accessories });
    if (this.state.params.formType.toLowerCase() === "upcare") {
      this.updateTotalMonthlyFee();
    } else {
      this.newCalculationsProductFee();
    }
  };

  handleFormInformationChange = (info) => {
    let formInformation = this.state.formInformation;
    for (let id in info) {
      formInformation[id] = info[id];
    }
    this.setState({
      formInformation: formInformation,
    });
  };

  handleCreditInfoChange = (info) => {
    let creditInfo = this.state.creditInfo;
    for (let id in info) {
      creditInfo[id] = info[id];
    }
    this.setState({
      creditInfo: creditInfo,
    });
  };

  handleContractFileChange = (info) => {
    let contractFile = this.state.contractFile;
    for (let id in info) {
      contractFile[id] = info[id];
    }
    this.setState({
      contractFile: contractFile,
    });
  };

  handleCreditFileChange = (info) => {
    let creditFile = this.state.creditFile;
    for (let id in info) {
      creditFile[id] = info[id];
    }
    this.setState({
      creditFile: creditFile,
    });
  };

  /**
   *
   * @param {Object} event
   *
   * Handles checkbox check depending on case.
   */
  handleChecked = async (event) => {
    let newState;
    let newCustomerState;
    let formInformation = this.state.formInformation;
    let newDealerInformation = this.state.newDealerInformation;
    switch (event.target.id) {
      case "quote_check":
        newState = this.state.formInformation.quoteChecked ? false : true;
        if (newState && this.state.formInformation.orderChecked) {
          formInformation.orderChecked = false;
        }
        formInformation.quoteChecked = newState;
        this.setState({ formInformation: formInformation });
        break;
      case "order_check":
        newCustomerState = this.state.customerInformation;
        newState = this.state.formInformation.orderChecked ? false : true;
        if (!newState) {
          formInformation.idChecked = false;
        }
        if (this.state.params.formType.toLowerCase() === "at") {
          newCustomerState["pep"] = this.state.labels.pep[0];
          newCustomerState["idType"] = this.state.labels.id_select[0];
        }
        newCustomerState["idNumber"] = "";
        // newCustomerState["repurchase"] = this.state.labels.dealer_repurchase;
        newCustomerState.signatories.signatory1.idTypeSignatory = "";
        newCustomerState.signatories.signatory1.pepSignatory = "";
        if (newState && this.state.formInformation.quoteChecked) {
          formInformation.quoteChecked = false;
        }
        if (
          this.state.formInformation.customer === "Private" &&
          socialSecurityNumberCountries.includes(
            this.state.params.lang.toLowerCase(),
          )
        ) {
          formInformation.fillBySSN = true;
        }
        formInformation.orderChecked = newState;
        this.setState({
          formInformation: formInformation,
          customerInformation: newCustomerState,
        });
        break;
      case "limited_company":
        formInformation.limitedCompanyChecked = true;
        formInformation.limitedCompanyNotChecked = false;
        this.setState({ formInformation: formInformation });
        break;
      case "limited_company_no":
        formInformation.limitedCompanyChecked = false;
        formInformation.limitedCompanyNotChecked = true;

        this.setState({ formInformation: formInformation });
        break;
      case "id_checked":
        newState = this.state.formInformation.idChecked ? false : true;
        formInformation.idChecked = newState;
        this.setState({ formInformation: formInformation });
        break;
      case "peppol_checked":
        newState = this.state.formInformation.peppol ? false : true;
        formInformation.peppol = newState;
        this.setState({ formInformation: formInformation });
        break;
      case "legal_signatory_provided":
        newState = this.state.formInformation.legalSignatoryChecked
          ? false
          : true;
        formInformation.legalSignatoryChecked = newState;
        this.setState({ formInformation: formInformation });
        break;
      case "new_dealer_yes":
        this.setState({
          openPopup: true,
          formInformation: {
            ...this.state.formInformation,
            newDealerChecked: false,
            newDealerNotChecked: false,
          },
        });
        /* Code is commented out to prevent dealer input and show a popup redirecting them to the old portal.
        This stays as a reference for what was changed. */

        /* formInformation.newDealerChecked = true;
        formInformation.newDealerNotChecked = false;
        this.setState({ formInformation: formInformation });*/
        break;
      case "new_dealer_no":
        formInformation.newDealerNotChecked = true;
        formInformation.newDealerChecked = false;
        this.setState({ formInformation: formInformation });
        break;
      case "verify_new_dealer":
        newState = this.state.newDealerInformation.verifyNewDealer
          ? false
          : true;
        newDealerInformation.verifyNewDealer = newState;
        this.setState({ newDealerInformation: newDealerInformation });
        break;
      case "amp_checked":
        newState = this.state.formInformation.ampChecked ? false : true;
        formInformation.ampChecked = newState;
        this.setState({ formInformation: formInformation });
        break;
      case "ceora_campaign":
        if (
          this.state.formInformation.ceoraCampaign &&
          this.state.formInformation.contractLengths.length < 2
        ) {
          let data = await getCountryInformation(
            "hcs",
            this.state.params.lang.toLowerCase(),
            this.state.params.formType.toLowerCase(),
          );
          data = data.data;
          formInformation.contractLengths = data["Products"]["contractLengths"];
        } else {
          formInformation.contractLength = 60;
        }
        let data = {};
        data["name"] = null;
        data["service"] = 0;
        data["upCare"] = false;
        for (let product in this.state.productsValues) {
          this.updateProduct(data, product);
        }
        if (this.state.params.formType === "flexpro") {
          this.newCalculationsProductFee();
        } else {
          this.updateTotalMonthlyFee();
        }
        newState = this.state.formInformation.ceoraCampaign ? false : true;
        formInformation.ceoraCampaign = newState;
        this.setState({ formInformation: formInformation });
        break;
      default:
        throw Error("Unknown button ID");
    }
  };

  /**
   *
   * @param {Object} event
   *
   * Handles input in password box.
   */

  handleInput = (event) => {
    let id = event.target.id;
    let data = {};
    if (id === "password_input") {
      data["passwordInput"] = event.target.value;
    }
    this.setState(data);
  };

  handleSelectChange = (event) => {
    let value = event.target.value;
    let state = this.state;
    switch (value) {
      case "fr":
        state.labels = this.state.allLabels.fr;
        state.beLanguage = "fr";
        this.setState(state);
        break;
      case "nl":
        state.labels = this.state.allLabels.nl;
        state.beLanguage = "nl";
        this.setState(state);
        break;
      default:
        throw Error("Unknwon ID");
    }
  };

  handleClick = async (event) => {
    let id = event.target.id;
    if (id === "password_check") {
      const isPasswordValid =
        this.state.passwordInput === CEORA_CAMPAIGN_PASSWORD;

      if (isPasswordValid) {
        this.setState({ isVerified: true });
      } else {
        alert("Wrong password.");
        let event = { target: { id: "password_input", value: "" } };
        this.handleInput(event);
      }
    }
  };

  /**
   *
   * @param {String} value
   *
   * Switches the current formState to new value.
   */
  switchFormState = (value) => {
    let state = this.state;
    state.formInformation.formState = value;
    const lang = this.state.params.lang.toLowerCase();
    const formType = this.state.params.formType.toLowerCase();
    if (
      formType === "leaseplus" &&
      (lang === "fr" || lang === "de" || lang === "uk")
    ) {
      if (value === "edit") {
        state.stepCounter = 0;
      } else if (value === "confidentiality_notice") {
        state.stepCounter = 1;
      } else if (value === "credit_check") {
        state.stepCounter = 2;
        state.openPopup = true;
      } else if (value === "payment_info") {
        state.stepCounter = 3;
      } else if (value === "create_contract") {
        state.stepCounter = 4;
      } else if (value === "transfer_agreement") {
        state.stepCounter = 5;
      } else if (value === "completed") {
        state.stepCounter = 6;
      }
    } else if (formType === "upcare" && (lang === "uk" || lang === "se")) {
      if (value === "edit") {
        state.stepCounter = 0;
      } else if (value === "confidentiality_notice") {
        state.stepCounter = 1;
      } else if (value === "payment_info") {
        state.stepCounter = 2;
      } else if (value === "completed") {
        state.stepCounter = 3;
      }
    } else {
      if (value === "edit") {
        state.stepCounter = 0;
      } else if (value === "confidentiality_notice") {
        state.stepCounter = 1;
      } else if (value === "credit_check") {
        state.stepCounter = 2;
      } else if (value === "create_contract") {
        state.stepCounter = 3;
      } else if (value === "completed") {
        state.stepCounter = 4;
      }
    }
    this.setState(state);
  };

  /**
   *
   * @param {Object} event
   *
   * Updates the contractLenght in state to new value, calls for update of totalMonthlyFee.
   */
  changeContractLength = (event) => {
    let state = this.state;
    const newLength = event.target.value;

    state.formInformation.contractLength = newLength;

    if (newLength === 24) {
      state.variables = {
        ...state.baseVariables,
        ...state.usedVariables,
      };
    } else {
      state.variables = { ...state.baseVariables };
    }

    this.setState(state);
    if (this.state.params.formType.toLowerCase() === "flexpro") {
      let data = {};
      data["name"] = null;
      data["service"] = 0;
      data["upCare"] = false;
      for (let product in this.state.productsValues) {
        this.updateProduct(data, product);
      }
    }
    if (this.state.params.formType.toLowerCase() === "upcare") {
      const lang = this.state.params.lang.toLowerCase();
      getUpCareProducts(lang, newLength, "ceora_campaign").then(
        (validProducts) => {
          for (const productId in this.state.productsValues) {
            const name = this.state.productsValues[productId].name;
            if (name && !validProducts.includes(name)) {
              this.updateProduct(
                {
                  name: null,
                  price: 0,
                  purchasePrice: 0,
                  residualPrice: 0,
                  installation: 0,
                  totalProductPrice: 0,
                  finished: false,
                },
                productId,
              );
            }
          }
          this.setState({ products: validProducts }, () => {
            this.updateTotalMonthlyFee();
          });
        },
      );
    }
    if (this.state.params.formType.toLowerCase() === "construction") {
      let data = {};
      data["residual"] = 10;
      data["name"] = null;
      data["service"] = 0;
      for (let product in this.state.productsValues) {
        this.updateProduct(data, product);
      }
    }
    if (this.state.params.formType.toLowerCase() === "leaseplus") {
      const lang = this.state.params.lang.toLowerCase();
      const formType = this.state.params.formType.toLowerCase();
      const newLength = event.target.value;

      if (newLength === 24) {
        axios
          .get(
            `${configSource.ROOT}forminfo/products/${lang}/${formType}/${newLength}`,
          )
          .then((response) => {
            let products = [];
            for (const product of response.data) {
              products.push(product.name);
            }
            this.setState(
              {
                ...state,
                variables:
                  newLength === 24
                    ? { ...state.baseVariables, ...state.usedVariables }
                    : { ...state.baseVariables },

                products: products,
                productsValues: {
                  product1: {
                    deliveryDate: null,
                    productList: "productList2",
                    name: null,
                    quantity: 1,
                    serial: [],
                    price: 0,
                    service: 0,
                    purchasePrice: 0,
                    installation: 0,
                    residual: 10,
                    residualPrice: 0,
                    accessory: [null],
                    accessoryPrice: [0],
                    purchasePriceAccessory: [0],
                    installationAccessory: [0],
                    residualPriceAccessory: [0],
                    residualPriceAccessorySum: 0,
                    purchasePriceAccessorySum: 0,
                    installationAccessorySum: 0,
                    upCare: false,
                    firstIncresedRent: 0,
                    totalProductPrice: 0,
                    finished: false,
                    ownServiceIncludes: {
                      storage: false,
                      consumables: false,
                      education: false,
                      maintenance: false,
                      repairs: true,
                      other: false,
                      noService: false,
                    },
                    manuallyModified: {
                      installationModified: false,
                    },
                  },
                },
                formInformation: {
                  ...this.state.formInformation,
                  productCondition: "used",
                },
              },
              () => {
                this.updateTotalMonthlyFee();
              },
            );
          });
      } else {
        this.updateTotalMonthlyFee();
      }
    } else if (
      this.state.params.formType.toLowerCase() === "flexpro" ||
      this.state.params.formType.toLowerCase() === "construction"
    ) {
      this.newCalculationsProductFee();
    }
  };

  showInvalid = (newValue = true) => {
    let newFormInformation = this.state.formInformation;
    newFormInformation.showInvalid = newValue;
    this.setState({
      formInformation: newFormInformation,
    });
  };

  handleAdyenErrorMessage = (errorMessage) => {
    const lang = this.state.params.lang.toLowerCase();
    let popupHeaderMessage;

    if (errorMessage.includes(ADYEN_ERROR_TYPES.EQUIPMENT_NOT_EXIST)) {
      popupHeaderMessage = this.state.labels.product_error || "Product error";
    } else if (
      errorMessage.includes(ADYEN_ERROR_TYPES.BUSINESS_PARTNER_NOT_EXIST)
    ) {
      popupHeaderMessage =
        this.state.labels.husqvarna_number_error || "Error Husqvarna number";
    }

    const popupMessage = getAdyenErrorMessage(
      errorMessage,
      lang,
      this.state.customerInformation.customerNumber,
    );

    this.setState({
      openPopupAdyen: true,
      popupMessage,
      popupHeaderMessage,
    });
  };
  createAdyen = async () => {
    const lang = this.state.params.lang.toLowerCase();
    const formType = this.state.params.formType.toLowerCase();
    const getAccessoryCode = (formType) => {
      const map = {
        leaseplus: "922222222",
        upcare: "91111111",
      };

      return map[formType] ?? "922222222";
    };
    if (adyenCountriesMap[formType].includes(lang)) {
      const accessoryTranslation = this.state.labels.accessory;
      function updateAccessoryName(productValues) {
        const updatedProducts = {};

        Object.entries(productValues).forEach(([key, product]) => {
          updatedProducts[key] = {
            ...product,
            name:
              product.name === accessoryTranslation
                ? `${getAccessoryCode(formType)} ${accessoryTranslation}`
                : product.name,
          };
        });

        return updatedProducts;
      }

      let productsValues = this.state.productsValues;

      if (formType === "upcare") {
        const accessories = Object.values(this.state.accessories || {});

        if (accessories.length > 0) {
          const totalAccessoriesPrice = accessories.reduce(
            (sum, item) => sum + (item.TotalAccessoriesPrice || 0),
            0,
          );

          const accessoryProduct = {
            deliveryDate: null,
            productList: "productList1",
            name: this.state.labels.accessory,
            quantity: 1,
            serial: [],
            price: 0,
            accessory: [null],
            accessoryPrice: [0],
            service: 0,
            purchasePrice: totalAccessoriesPrice,
            residualPrice: 1, //currently hardcoded for upcare (used for UK)
            installation: 0,
            residual: 0,
            upCare: false,
            firstIncresedRent: 0,
            totalProductPrice: null,
            finished: true,
            purchasePriceAccessory: [0],
            installationAccessory: [0],
            residualPriceAccessory: [0],
            residualPriceAccessorySum: 0,
            purchasePriceAccessorySum: 0,
            installationAccessorySum: 0,
            ownServiceIncludes: {
              storage: false,
              consumables: false,
              education: false,
              maintenance: false,
              repairs: true,
              other: false,
            },
            manuallyModified: {
              installationModified: true,
            },
          };
          productsValues = { ...this.state.productsValues };

          const nextProductNumber = Object.keys(productsValues).length + 1;

          productsValues[`product${nextProductNumber}`] = accessoryProduct;
        }
      }

      const adyenResponse = await createAdyen({
        productsValues: updateAccessoryName(productsValues),
        customerInformation: this.state.customerInformation,
        formInformation: this.state.formInformation,
        params: this.state.params,
        variables: this.state.variables,
      });

      console.log("adyenResponse", adyenResponse.data.data);

      if (adyenResponse.data.success) {
        this.setState({ paymentId: adyenResponse.data.data.paymentId });
        await this.setStateAsync({
          formInformation: {
            ...this.state.formInformation,
            paymentId: adyenResponse.data.data.paymentId,
            contractNumber: adyenResponse.data.data.contractNo,
          },
        });
        return { success: true };
      } else {
        const errorMsg = adyenResponse.data.data.error;

        if (errorMsg.includes(ADYEN_ERROR_TYPES.EQUIPMENT_NOT_EXIST)) {
          this.handleAdyenErrorMessage(errorMsg);
          await this.sendToCRMAdyenFailed(errorMsg);
        } else if (
          errorMsg.includes(ADYEN_ERROR_TYPES.BUSINESS_PARTNER_NOT_EXIST)
        ) {
          this.handleAdyenErrorMessage(errorMsg);
        } else {
          await this.sendToCRMAdyenFailed(errorMsg);
          alert("Order sent for manual review..");
          this.switchFormState("completed");
        }

        return { success: false };
      }
    }
  };

  setDirectDebitState = () => {
    let formInformation = this.state.formInformation;
    formInformation.directDebit = true;
    this.setState({ formInformation: formInformation });
  };

  sendContract = async (info) => {
    await this.state.contractPdfPromise;
    const lang = this.state.params.lang.toLowerCase();
    //different flows depending on country

    //also add the orderinfo to db in backend
    //here the case is created after the contract is signed

    // Consider skipping createOrder for DE !
    if (lang !== "fr" && lang !== "de" && lang !== "uk") {
      await createOrder({
        id: this.state.formInformation.contractNumber,
        productsValues: this.state.productsValues,
        customerInformation: this.state.customerInformation,
        formInformation: this.state.formInformation,
        params: this.state.params,
        variables: this.state.variables,
      });
    }

    let { language, signingMethod } = this.getSigningMethodAndCountryCode(
      this.state.params.lang.toLowerCase(),
    );
    /* Create formdata and append all parameters for the request */
    const createFormData = (file, fileName) => {
      const formData = new FormData();
      formData.append(
        "givenName",
        this.state.customerInformation.customerFirstName,
      );
      formData.append(
        "familyName",
        this.state.customerInformation.customerLastName,
      );
      formData.append("language", language);
      formData.append("email", this.state.customerInformation.customerEmail);
      formData.append("sms", true);
      formData.append(
        "telephone",
        this.state.customerInformation.customerPhone,
      );
      formData.append("name", fileName);
      formData.append(
        "contractNumber",
        this.state.formInformation.contractNumber,
      );
      formData.append("file", file);
      formData.append("signingMethod", signingMethod);
      return formData;
    };

    if (lang === "uk" && this.state.preContractFile.file) {
      await verifiedRequest(
        createFormData(
          this.state.preContractFile.file,
          this.state.preContractFile.fileName,
        ),
      );
      uploadDocuments(
        [
          {
            file: this.state.preContractFile.file,
            fileName: this.state.preContractFile.fileName,
            documentType: 1,
            description: "Pre-Contract (unsigned)",
          },
        ],
        this.state.formInformation.contractNumber,
        lang,
      ).catch((err) =>
        console.error("Pre-contract upload failed:", err.message),
      );
    }

    const verifiedResponse = await verifiedRequest(
      createFormData(
        this.state.contractFile.file,
        this.state.contractFile.fileName,
      ),
    );
    return verifiedResponse;
  };

  /**
   *
   * @returns Boolean
   */
  validateFormInputs = () => {
    const lang = this.state.params.lang.toLowerCase();
    if (configSource["DEBUG"]) return true;
    if (this.state.formInformation.totalMonthlyFee < 0.1) {
      this.showInvalid();
      alert("All required fields are not filled in1");
      return false;
    }
    const allowedFormType = this.state.params.formType.toLowerCase();
    const isRelevantFormType =
      allowedFormType === "flexpro" || allowedFormType === "upcare";
    const legalSignatoryConfirmed =
      !isRelevantFormType ||
      this.state.formInformation.legalSignatoryChecked === true;

    if (
      allowedFormType === "upcare" &&
      this.state.formInformation.orderChecked &&
      !this.state.formInformation.limitedCompanyChecked &&
      !this.state.formInformation.limitedCompanyNotChecked
    ) {
      this.showInvalid();
      alert("Please select Yes or No for Limited company.");
      return false;
    }
    if (
      allowedFormType === "upcare" &&
      this.state.formInformation.orderChecked &&
      this.state.formInformation.limitedCompanyNotChecked &&
      this.state.extraFiles.length < 1 &&
      this.state.customerInformation.companyTypeKey !== "municipality"
    ) {
      this.showInvalid();
      alert("Please attach the customer's latest annual report.");
      return false;
    }
    if (!legalSignatoryConfirmed && this.state.formInformation.orderChecked) {
      alert(this.state.labels.signatory_warning);
      return false;
    }
    if (
      this.state.formInformation.productCondition === "used" &&
      this.state.formInformation.customContractNumber === ""
    ) {
      this.showInvalid();
      alert("Contract number is required for used products");
      return false;
    }
    if (
      this.state.accessorySinglePrice < 0.1 &&
      this.state.accessoriesVisible
    ) {
      this.showInvalid();
      alert("Accessory price is not filled in.");
      return false;
    }
    const isCustomerEmailInvalid = !validateEmail(
      this.state.customerInformation.customerEmail,
    );
    const isCustomerInvoiceEmailInvalid =
      this.state.customerInformation.customerInvoiceEmail &&
      !validateEmail(this.state.customerInformation.customerInvoiceEmail);
    const isDealerEmailInvalid = !validateEmail(
      this.state.customerInformation.dealerEmail,
    );
    const isdealerInvoiceEmailInvalid =
      this.state.customerInformation.dealerInvoiceEmail &&
      !validateEmail(this.state.customerInformation.dealerInvoiceEmail);
    const isSignatoryEmailInvalid = Object.values(
      this.state.customerInformation.signatories,
    ).some(
      (signatory) =>
        signatory.emailSignatory && !validateEmail(signatory.emailSignatory),
    );
    if (
      (this.state.formInformation.quoteChecked ||
        this.state.formInformation.orderChecked) &&
      (isCustomerEmailInvalid ||
        isCustomerInvoiceEmailInvalid ||
        isDealerEmailInvalid ||
        isdealerInvoiceEmailInvalid ||
        isSignatoryEmailInvalid)
    ) {
      this.showInvalid();
      alert(
        "The entered email address is not valid, please use a valid email.",
      );
      return false;
    }
    if (
      this.state.formInformation.orderChecked &&
      (!(
        (this.state.customerInformation.businessFinished ||
          this.state.customerInformation.privateFinished) &&
        this.state.customerInformation.identificationFinished &&
        this.state.customerInformation.dealerFinished
      ) ||
        !(
          !this.state.formInformation.newDealerChecked ||
          this.state.newDealerInformation.newDealerFinished
        ))
    ) {
      this.showInvalid();

      alert("All required fields are not filled in2");
      return false;
    }
    if (
      (lang === "fr" ||
        lang === "de" ||
        lang === "uk" ||
        lang === "se" ||
        lang === "no" ||
        lang === "dk") && //Because of HubSpot integration
      this.state.formInformation.orderChecked &&
      this.state.customerInformation.customerEmail ===
        this.state.customerInformation.dealerEmail
    ) {
      this.showInvalid();
      const emailLabel =
        allowedFormType === "upcare" || allowedFormType === "flexpro"
          ? "General contact E-mail"
          : "The customer email address";
      alert(`${emailLabel} and dealer email address cannot be the same.`);
      return false;
    }
    if (
      (allowedFormType === "upcare" || allowedFormType === "flexpro") &&
      this.state.formInformation.orderChecked
    ) {
      const invoiceEmail = this.state.customerInformation.customerInvoiceEmail;
      const customerEmail = this.state.customerInformation.customerEmail;
      if (invoiceEmail === customerEmail) {
        this.showInvalid();
        alert("General contact E-mail and Invoice E-mail cannot be the same.");
        return false;
      }

      const isInvoiceEmailMatchingSignatory = Object.values(
        this.state.customerInformation.signatories,
      ).some((signatory) => signatory.emailSignatory === invoiceEmail);

      if (isInvoiceEmailMatchingSignatory) {
        this.showInvalid();
        alert("Invoice E-mail cannot be the same as a Signatory E-mail.");
        return false;
      }
    }
    if (
      this.state.formInformation.quoteChecked &&
      !(
        this.state.customerInformation.quoteInformationFinished &&
        this.state.customerInformation.dealerFinished
      )
    ) {
      this.showInvalid();
      alert("All required fields are not filled in3");
      return false;
    }
    for (let product in this.state.productsValues) {
      if (!this.state.productsValues[product].name) {
        this.showInvalid();
        alert("All required fields are not filled in");
        return false;
      }
      if (
        this.state.productsValues[product]["finished"] === undefined ||
        this.state.productsValues[product]["finished"] === false
      ) {
        this.showInvalid();
        alert("All required fields are not filled in4");
        return false;
      }
      if (this.state.formInformation.lifeOffer === "secondLife") {
        const accessoryLabel = this.state.labels.accessory;
        const hasInvalidSerial = Object.values(this.state.productsValues).some(
          (p) =>
            p.name !== accessoryLabel &&
            (!Array.isArray(p.serial) || p.serial.length === 0),
        );

        if (hasInvalidSerial) {
          this.showInvalid();
          alert("Serial number is required for used products");
          return false;
        }
      }
    }
    if (this.state.accFailed && this.state.accFailed.length > 0) {
      this.showInvalid();
      alert(
        this.props.params.lang === "fr"
          ? "Certains accessoires n'ont pas été trouvés ou n'ont pas de prix valide"
          : "Some accessories could not be found or have no valid price.",
      );
      return false;
    }
    if (
      this.state.params.lang === "at" &&
      this.state.extraFiles.length < 1 &&
      this.state.formInformation.orderChecked
    ) {
      this.showInvalid();
      alert(this.state.labels.must_attach);
      return false;
    }
    /*if (
      this.props.params.lang === "fr" &&
      this.props.params.formType === "leaseplus" &&
      this.state.extraFiles.length < 1 &&
      this.state.formInformation.orderChecked
    ) {
      this.showInvalid();
      alert(
        "La facture d'électricité ou de téléphone du client doit être téléchargée pour pouvoir envoyer la demande à HCS."
      );
      return false;
    }*/
    this.showInvalid(false);
    return true;
  };

  /**
   *
   * @returns Boolean
   *
   * Check the params to validate that the form requested exists.
   */
  validateParams = () => {
    const allowedArgs = config.ALLOWED_ARGS;
    if (
      Object.keys(allowedArgs["hcs"]).includes(
        this.props.params.lang.toLowerCase(),
      ) &&
      allowedArgs["hcs"][this.props.params.lang.toLowerCase()].includes(
        this.props.params.formType.toLowerCase(),
      )
    ) {
      return true;
    }
    return false;
  };

  /**
   *
   * @param {string} id
   * @returns ReactElement || null
   *
   * Creates a ReactElement depending on formType and returns it.
   * If unknown formType return null.
   */

  generateProduct = (id) => {
    const standardProps = {
      key: id,
      id: id,
      number: id.charAt(id.length - 1),
      productValues: this.state.productsValues[id],
      formInformation: this.state.formInformation,
      labels: this.state?.labels,
      variables: this.state?.variables,
      params: this.state.params,
      updateProduct: this.updateProduct,
    };
    const index = this.state.formInformation.contractLengths.indexOf(
      this.state.formInformation.contractLength,
    );
    let productList;
    switch (this.state.params.formType.toLowerCase()) {
      case "upcare":
        const upCareProps = {
          color: this.state.color,
          products: { productList1: this.state.products },
          updateTotalMonthlyFee: this.updateTotalMonthlyFee,
          handleChecked: this.handleChecked,
        };
        return React.createElement(
          UpCareProduct,
          Object.assign(standardProps, upCareProps),
        );
      case "leaseplus":
        let products = [];
        if (
          this.state.params.formType.toLowerCase() === "leaseplus" &&
          this.state.customerInformation.repurchase ===
            this.state.labels.dealer_repurchase
        ) {
          products = this.state.products;
        } else {
          if (Array.isArray(this.state.products)) {
            const husqvarnaBuyPackProducts = this.state.products.filter(
              (item) =>
                item.toLowerCase().includes("automower") ||
                item.toLowerCase().includes("am") ||
                item.includes("EPOS™ RS5 Reference Station") ||
                item.includes("EPOS™ RS1 Reference Station") ||
                item.includes("Husqvarna EPOS™ RS1 Reference Station") ||
                item.includes("Husqvarna EPOS™ Plug-in"),
            );

            products = husqvarnaBuyPackProducts;
          }
        }
        const leasePlusProps = {
          accFailed: this.state.accFailed,
          products: products,
          accessories: this.state.accessories,
          updateTotalMonthlyFee: this.updateTotalMonthlyFee,
          removeLeasePlusAccessory: this.removeLeasePlusAccessory,
          addLeasePlusAccessory: this.addLeasePlusAccessory,
        };

        //this removes accesory from product section
        if (standardProps.productValues.name === this.state.labels.accessory)
          return;

        return React.createElement(
          LeasePlusProduct,
          Object.assign(standardProps, leasePlusProps),
        );
      case "flexpro":
        let flexProProps;
        if (this.state.params.lang.toLowerCase() !== "nl") {
          if (index === 0) {
            productList = this.state.products.productList1;
          } else if (index === 1) {
            productList = this.state.products.productList2;
          } else if (index === 2) {
            productList = this.state.products.productList3;
          } else {
            productList = this.state.products.productList1;
          }
        } else {
          productList = this.state.products.productList1;
        }
        if (this.state.formInformation.ceoraCampaign) {
          let newProductList = {};
          for (const [key, value] of Object.entries(productList)) {
            if (value?.campaign <= 1) {
              newProductList[key] = value;
            }
          }
          productList = newProductList;
        }
        flexProProps = {
          products: productList,
          calculateNewFee: this.newCalculationsProductFee,
        };

        return React.createElement(
          FlexProProduct,
          Object.assign(standardProps, flexProProps),
        );
      case "flexprivate":
        const flexPrivateProps = {
          products: this.state.products.productList1,
          calculateNewFee: this.newCalculationsProductFee,
        };
        return React.createElement(
          FlexPrivateProduct,
          Object.assign(standardProps, flexPrivateProps),
        );
      case "construction":
        const constructionProps = {
          products: this.state.products,
          calculateNewFee: this.newCalculationsProductFee,
        };
        return React.createElement(
          ConstructionProduct,
          Object.assign(standardProps, constructionProps),
        );
      default:
        return null;
    }
  };

  handleDealerButtonClick = () => {
    this.context.signinRedirect();
  };

  getStringWithLinks = (text) => {
    if (text !== undefined) {
      const textWithClickableLinks = text
        .replace(
          /https?:\/\/[^\s]+/g,
          (url) =>
            `<a href="${url}" target="_blank" rel="noopener noreferrer"><b>${
              this.state.labels.here + "."
            }</b></a>`,
        )
        .replace(
          /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
          (email) => `<a href="mailto:${email}">${email}</a>`,
        );
      return textWithClickableLinks;
    } else {
      return "";
    }
  };

  getSigningMethodAndCountryCode = (country) => {
    let language, signingMethod;
    switch (country) {
      case "at":
        language = "de-AT";
        signingMethod = "touch-sign";
        break;
      case "de":
        language = "de-DE";
        signingMethod = "touch-sign";
        break;
      case "dk":
        language = "da_DK";
        signingMethod = "nets-eident-dk";
        break;
      case "fi":
        language = "fi_FI";
        signingMethod = "touch-sign";
        break;
      case "fr":
        language = "fr-FR";
        signingMethod = "touch-sign";
        break;
      case "nl":
        language = "nl-NL";
        signingMethod = "touch-sign";
        break;
      case "no":
        language = "nb_NO";
        signingMethod = "bankid-no";
        break;
      case "se":
        language = "sv_SE";
        signingMethod = "bankid-se";
        break;
      case "uk":
        language = "en_EN";
        signingMethod = "touch-sign";
        break;
      default:
        language = "en_EN";
        signingMethod = "touch-sign";
        return;
    }
    return { language, signingMethod };
  };
  sendToCRMAdyenFailed = async (error) => {
    const isEquipmentError = error.includes(
      ADYEN_ERROR_TYPES.EQUIPMENT_NOT_EXIST,
    );

    const isProFinanceError = error.includes("ProFinance creation failed");

    const props = {
      creditFile: this.state.creditFile,
      contractFile: this.state.contractFile,
      labels: this.state.labels,
      params: this.state.params,
      switchFormState: this.switchFormState,
      formInformation: this.state.formInformation,
      productsValues: this.state.productsValues,
      customerInformation: this.state.customerInformation,
      accessories: this.state.accessories,
      extraFiles: this.state.extraFiles,
      products: this.state.products,
      variables: this.state.variables,
      newDealerInformation: this.state.newDealerInformation,
      headerImgSrc: this.state.headerImgSrc,
      apiError: "OBS!! " + error,
      privateEmail: isEquipmentError || isProFinanceError,
    };

    const serverResponce = (res) => {
      if (res.status !== 200) {
        console.log(res.err);
      }
    };
    await sendOrder(props, true, serverResponce);
  };

  sendToCRMManualPayment = async (error) => {
    this.switchFormState("completed");
    const props = {
      creditFile: this.state.creditFile,
      contractFile: this.state.contractFile,
      labels: this.state.labels,
      params: this.state.params,
      switchFormState: this.switchFormState,
      formInformation: this.state.formInformation,
      productsValues: this.state.productsValues,
      customerInformation: this.state.customerInformation,
      accessories: this.state.accessories,
      extraFiles: this.state.extraFiles,
      products: this.state.products,
      variables: this.state.variables,
      newDealerInformation: this.state.newDealerInformation,
      headerImgSrc: this.state.headerImgSrc,
      apiError: "OBS!! " + error,
    };

    const serverResponce = (res) => {
      if (res.status === 200) {
        alert("Order sent for manual review.");
      } else {
        //if not
        console.log(res.err);
      }
    };
    await sendOrder(props, true, serverResponce);
  };

  //this function is used for sending order to CRM even if there is error during invoice check
  sendToCRMInvoiceUploadFailed = async () => {
    const props = {
      creditFile: this.state.creditFile,
      contractFile: this.state.contractFile,
      labels: this.state.labels,
      params: this.state.params,
      switchFormState: this.switchFormState,
      formInformation: this.state.formInformation,
      productsValues: this.state.productsValues,
      customerInformation: this.state.customerInformation,
      accessories: this.state.accessories,
      extraFiles: this.state.extraFiles,
      products: this.state.products,
      variables: this.state.variables,
      newDealerInformation: this.state.newDealerInformation,
      headerImgSrc: this.state.headerImgSrc,
      apiError: "OBS!! Faktura checken funkade inte eller gick inte igenom!",
    };

    const serverResponce = (res) => {
      if (res.status === 200) {
        //if the mail was successfuly sent
        this.switchFormState("completed");
      } else {
        //if not
        console.log(res.err);
      }
    };
    await sendOrder(props, true, serverResponce);
  };

  // this function is used for sending order to CRM even if there is error during CreditCheck
  sendBeforeCerditCheck = async () => {
    //Unnecessary for now, but might be needed in the future
    if (this.state.params.lang.toLowerCase() !== "fr") {
      await this.createContractPDf();
    }
    const props = {
      creditFile: this.state.creditFile,
      contractFile: this.state.contractFile,
      labels: this.state.labels,
      params: this.state.params,
      switchFormState: this.switchFormState,
      formInformation: this.state.formInformation,
      productsValues: this.state.productsValues,
      customerInformation: this.state.customerInformation,
      accessories: this.state.accessories,
      extraFiles: this.state.extraFiles,
      products: this.state.products,
      variables: this.state.variables,
      newDealerInformation: this.state.newDealerInformation,
      headerImgSrc: this.state.headerImgSrc,
      apiError: "OBS!! Kreditupplysningen funkade inte eller gick inte igenom!",
    };

    const serverResponce = (res) => {
      if (res.status === 200) {
        //if the mail was successfuly sent
        this.switchFormState("completed");
      } else {
        //if not
        console.log(res.err);
      }
    };
    await sendOrder(props, true, serverResponce);
  };

  sendTransferAgreementFailed = async () => {
    const props = {
      ...this.state,
      apiError: "OBS: Överlåtelseavtalet godkändes inte automatiskt",
    };

    const serverResponse = (res) => {
      if (res.status !== 200) {
        console.error("Fallback sendOrder failed:", res.err);
      }
    };

    await sendOrder(props, true, serverResponse);
  };

  adyenApiCall = async () => {
    const adyenResult = await this.createAdyen();
    return adyenResult && adyenResult.success;
  };

  // Adyen has already completed, so generate the contract PDF in the background
  // instead of blocking the user.
  leaseplusPDF = async (wasAdyenUsed) => {
    if (wasAdyenUsed) {
      const contractPdfPromise = this.generateLeasePlusContractPdf().catch(
        (error) => console.error("Contract PDF generation failed:", error),
      );
      this.setState({ contractPdfPromise });
      return true;
    }

    await this.generateLeasePlusContractPdf();
    return true;
  };

  createContractPDf = async () => {
    const lang = this.state.params.lang.toLowerCase();
    const formType = this.state.params.formType.toLowerCase();

    if (
      lang !== "fr" &&
      lang !== "de" &&
      lang !== "uk" &&
      !(
        (lang === "se" || lang === "no" || lang === "jp") &&
        formType === "upcare"
      )
    ) {
      const contractNumber = await getContractNumber(
        this.state.params.lang.toLowerCase(),
      );

      await new Promise((resolve) => {
        this.setState(
          (prevState) => ({
            formInformation: {
              ...prevState.formInformation,
              contractNumber,
            },
          }),
          resolve,
        );
      });
    }

    if (formType === "upcare") {
      const needsAdyen =
        adyenCountriesMap.upcare.includes(lang) &&
        this.state.formInformation.formState !== "credit_check";
      if (needsAdyen) {
        const canProceed = await this.adyenApiCall();
        if (!canProceed) return false;
      }

      const hireAgreementPdfPromise = this.generateHireAgreementPdf().catch(
        (error) =>
          console.error("Hire agreement PDF generation failed:", error),
      );
      this.setState({ hireAgreementPdfPromise });
      return true;
    }

    if (formType === "leaseplus") {
      const needsAdyen =
        adyenCountriesMap.leaseplus.includes(lang) &&
        this.state.formInformation.formState !== "credit_check";

      if (needsAdyen) {
        const canProceed = await this.adyenApiCall();
        if (!canProceed) return false;
      }

      if (lang === "uk") {
        return await this.createContractUKPdf();
      }

      return await this.leaseplusPDF(needsAdyen);
    }
  };

  generateLeasePlusContractPdf = async () => {
    let nrOfAccessories = 0;
    Object.keys(this.state.productsValues).forEach((id) => {
      if (this.state.productsValues[id].accessory !== null) {
        nrOfAccessories++;
      }
    });
    const contract = ReactDomServer.renderToStaticMarkup(
      React.createElement(CreateContract, {
        formInformation: this.state.formInformation,
        productsValues: this.state.productsValues,
        customerInformation: this.state.customerInformation,
        labels: this.state.labels,
        accessories: this.state.accessories,
        params: this.state.params,
        switchFormState: this.switchFormState,
        products: this.state.products,
        nrOfAccessories: nrOfAccessories,
      }),
    );
    const additionalPdfUrl =
      configSource.ROOT +
      `getimage?company=hcs&country=${this.state.params.lang.toLowerCase()}&type=lp_tos.pdf`;
    const firstPagePdf = "";
    /*configSource.ROOT +
      `getimage?company=hcs&country=${this.state.params.lang.toLowerCase()}&type=first_lp.pdf`;*/
    try {
      const requestBody = {
        htmlContent: contract,
        additionalPdfUrl: additionalPdfUrl,
        firstPagePdf: firstPagePdf,
      };
      const response = await getContractPDF(requestBody);
      if (response.data) {
        const uint8Array = new Uint8Array(response.data);
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        const fileURL = window.URL.createObjectURL(blob);

        await new Promise((resolve) =>
          this.setState(
            {
              contractFile: {
                file: blob,
                fileName:
                  this.state.params.lang.toLowerCase() === "fr"
                    ? `CONTRAT_DE_LOCATION_Lease_Plus_${this.state.formInformation.contractNumber}.pdf`
                    : this.state.params.lang.toLowerCase() === "de"
                      ? `HUSQVARNA_MIETVERTRAG_B2C_Lease_Plus_${this.state.formInformation.contractNumber}.pdf`
                      : "Hyreskontrakt_Lease_Plus.pdf",
                fileDisplay: fileURL,
                fileSize: blob.size,
              },
            },
            resolve,
          ),
        );
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  createContractUKPdf = async () => {
    const contractPdfPromise = Promise.all([
      this.generateUKPreContractPdf(),
      this.generateUKContractPdf(),
    ]).catch((error) =>
      console.error("UK contract PDF generation failed:", error),
    );
    this.setState({ contractPdfPromise });
    return true;
  };

  generateHireAgreementPdf = async () => {
    const hireAgreement = ReactDomServer.renderToStaticMarkup(
      React.createElement(CreateHireAgreement, {
        formInformation: this.state.formInformation,
        customerInformation: this.state.customerInformation,
        productsValues: this.state.productsValues,
        accessories: this.state.accessories,
        labels: this.state.labels,
        params: this.state.params,
        paymentId: this.state.paymentId,
      }),
    );

    try {
      const requestBody = {
        htmlContent: hireAgreement,
        additionalPdfUrl: "",
        firstPagePdf: "",
      };
      const response = await getContractPDF(requestBody);
      if (response.data) {
        const uint8Array = new Uint8Array(response.data);
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        const fileName = `Hire_Agreement_Request_${this.state.formInformation.contractNumber}.pdf`;
        await new Promise((resolve) =>
          this.setState(
            {
              hireAgreementFile: {
                file: blob,
                fileName,
                fileSize: blob.size,
              },
            },
            resolve,
          ),
        );
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  generateUKContractPdf = async () => {
    const contract = ReactDomServer.renderToStaticMarkup(
      React.createElement(CreateContractUk, {
        formInformation: this.state.formInformation,
        productsValues: this.state.productsValues,
        customerInformation: this.state.customerInformation,
        labels: this.state.labels,
        accessories: this.state.accessories,
        params: this.state.params,
        switchFormState: this.switchFormState,
        products: this.state.products,
      }),
    );
    const additionalPdfUrl =
      configSource.ROOT +
      `getimage?company=hcs&country=${this.state.params.lang.toLowerCase()}&type=lp_tos.pdf`;

    try {
      const requestBody = {
        htmlContent: contract,
        additionalPdfUrl,
        firstPagePdf: "",
      };
      const response = await getContractPDF(requestBody);
      if (response.data) {
        const uint8Array = new Uint8Array(response.data);
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        const fileURL = window.URL.createObjectURL(blob);
        const fileName = `Lease_Plus_Contract_${this.state.formInformation.contractNumber}.pdf`;
        await new Promise((resolve) =>
          this.setState(
            {
              contractFile: {
                file: blob,
                fileName,
                fileDisplay: fileURL,
                fileSize: blob.size,
              },
            },
            resolve,
          ),
        );
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  generateUKPreContractPdf = async () => {
    const contract = ReactDomServer.renderToStaticMarkup(
      React.createElement(CreatePreContractUk, {
        formInformation: this.state.formInformation,
        productsValues: this.state.productsValues,
        customerInformation: this.state.customerInformation,
        labels: this.state.labels,
        params: this.state.params,
      }),
    );

    try {
      const requestBody = {
        htmlContent: contract,
        additionalPdfUrl: "",
        firstPagePdf: "",
      };
      const response = await getContractPDF(requestBody);
      if (response.data) {
        const uint8Array = new Uint8Array(response.data);
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        const fileURL = window.URL.createObjectURL(blob);
        const fileName = `Lease_Plus_Pre_Contract_${this.state.formInformation.contractNumber}.pdf`;
        await new Promise((resolve) =>
          this.setState(
            {
              preContractFile: {
                file: blob,
                fileName,
                fileDisplay: fileURL,
                fileSize: blob.size,
              },
            },
            resolve,
          ),
        );
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  createTransferAgreementPdf = async () => {
    const lang = this.props.params.lang.toLowerCase();
    try {
      const htmlString = ReactDomServer.renderToStaticMarkup(
        React.createElement(CreateTransferAgreement, {
          params: this.state.params,
          labels: this.state.labels,
          formInformation: this.state.formInformation,
          productsValues: this.state.productsValues,
          customerInformation: this.state.customerInformation,
          products: this.state.products,
        }),
      );
      const fileName = {
        fr: {
          combinedName: "accord_de_transfert_kombinerad.pdf",
          name: "Accord_de_transfert.pdf",
        },
        de: {
          combinedName: "uebertragungsvertrag_kombiniert.pdf",
          name: "Uebertragungsvertrag.pdf",
        },
        uk: {
          combinedName: "transfer_agreement_combined.pdf",
          name: "Transfer_Agreement.pdf",
        },
      };
      const additionalPdfUrl =
        configSource.ROOT +
        `getimage?company=hcs&country=${lang}&type=${fileName[lang].combinedName}`;

      const firstPagePdf = "";
      const response = await getContractPDF({
        htmlContent: htmlString,
        additionalPdfUrl: additionalPdfUrl,
        firstPagePdf,
      });

      if (response) {
        const uint8Array = new Uint8Array(response.data);

        const blob = new Blob([uint8Array], { type: "application/pdf" });

        const fileURL = window.URL.createObjectURL(blob);
        await new Promise((resolve) =>
          this.setState(
            {
              transferAgreementFile: {
                file: blob,
                fileName: fileName[lang].name,
                fileDisplay: fileURL,
                fileSize: blob.size,
              },
            },
            resolve,
          ),
        );
      }
    } catch (err) {
      console.log("Error stack:", err.stack);
    }
  };
  async generateCompleteTransferAgreementPDF() {
    const lang = this.props.params.lang.toLowerCase();
    const {
      transferAgreementFile,
      formInformation,
      params,
      customerInformation,
      extraFiles,
    } = this.state;

    const existingPdfBuffer = await transferAgreementFile.file.arrayBuffer();
    const mainDoc = await PDFDocument.load(existingPdfBuffer);

    // Add signature page
    const signatureBytes = await GenerateSignaturePDF({
      params,
      formInformation,
      customerInformation,
    });
    const signatureDoc = await PDFDocument.load(signatureBytes);
    const [signaturePage] = await mainDoc.copyPages(signatureDoc, [0]);
    mainDoc.insertPage(0, signaturePage);

    const props = {
      labels: this.state.labels,
      params,
      formInformation,
      productsValues: this.state.productsValues,
      customerInformation,
      accessories: this.state.accessories,
      extraFiles,
      products: this.state.products,
      variables: this.state.variables,
      newDealerInformation: this.state.newDealerInformation,
      headerImgSrc: this.state.headerImgSrc,
    };
    const orderPdfBlob = await generateOrderPDF(props);
    const orderPdfBytes = await orderPdfBlob.arrayBuffer();
    const orderDoc = await PDFDocument.load(orderPdfBytes);

    const copiedOrderPages = await mainDoc.copyPages(
      orderDoc,
      orderDoc.getPageIndices(),
    );
    copiedOrderPages.forEach((page) => mainDoc.addPage(page));

    const fileName = {
      fr: `Accord_de_transfert_${formInformation.contractNumber}_signe.pdf`,
      de: `Uebertragungsvertrag_${formInformation.contractNumber}_signiert.pdf`,
      uk: `Transfer_Agreement_${formInformation.contractNumber}_signed.pdf`,
    };
    const finalBytes = await mainDoc.save();
    const blob = new Blob([finalBytes], { type: "application/pdf" });
    const filename = fileName[lang];
    const base64Data = await blobToBase64(blob);

    return {
      blob,
      filename,
      base64: base64Data,
      type: blob.type,
    };
  }
  generateFacturePdf = async () => {
    const pdfBytes = await GenerateFacturePDF({
      params: this.state.params,
      formInformation: this.state.formInformation,
      customerInformation: this.state.customerInformation,
      productsValues: this.state.productsValues,
      labels: this.state.labels,
      accessories: this.state.accessories,
    });

    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const fileName = {
      fr: `Facture_fictive_${this.state.formInformation.contractNumber}.pdf`,
      de: `Fiktive_rechnung_${this.state.formInformation.contractNumber}.pdf`,
      uk: `Mock_Invoice_${this.state.formInformation.contractNumber}.pdf`,
      se: `Fiktiv_faktura_${this.state.formInformation.contractNumber}.pdf`,
    };
    const lang = this.state.params.lang.toLowerCase();
    const filename = fileName[lang];

    const base64Data = await blobToBase64(blob);

    return {
      blob,
      filename,
      base64: base64Data,
      type: blob.type,
    };
  };

  completeTransferAgreementPDF = async () => {
    try {
      const transferAgreement =
        await this.generateCompleteTransferAgreementPDF();
      const facture = await this.generateFacturePdf();

      this.setState((prev) => ({
        transferAgreementFile: {
          ...prev.transferAgreementFile,
          file: transferAgreement.blob,
          fileName: transferAgreement.filename,
          fileSize: transferAgreement.blob.size,
        },
      }));

      try {
        const caseNo = this.state.formInformation.contractNumber;
        const country = this.props.params.lang.toLowerCase();
        const privacyNoticeBlob = await this.fetchConfidentialityPDF();
        const electricityBill = this.state.extraFiles[0];
        const electricityBillName =
          electricityBill?.fileName || electricityBill?.name;

        const documents = [
          {
            file: privacyNoticeBlob,
            fileName: "confidentiality_message.pdf",
            documentType: 1,
            description: "Privacy Notice",
          },
          ...(country === "fr"
            ? [
                {
                  file: electricityBill,
                  fileName: electricityBillName,
                  documentType: 22,
                  description: "Electricity Bill",
                },
              ]
            : country === "uk"
              ? [] // TODO: add credit check for UK once available
              : [
                  {
                    file: this.state.creditFile.file,
                    fileName: this.state.creditFile.fileName,
                    documentType: 22,
                    description: "Credit Check",
                  },
                ]),
          {
            file: transferAgreement.blob,
            fileName: transferAgreement.filename,
            documentType: 21,
            description: "Transfer Agreement",
          },
        ];
        await uploadDocuments(documents, caseNo, country);
        console.log("All documents uploaded successfully");
      } catch (err) {
        console.error("Document upload failed:", err.message);
        await this.sendTransferAgreementFailed();
      }

      let data = {
        ...this.state,
        transferAgreementFile: {
          ...this.state.transferAgreementFile,
          file: transferAgreement.blob,
          fileName: transferAgreement.filename,
          fileSize: transferAgreement.blob.size,
        },
        factureFictive: {
          file: facture.blob,
          fileName: facture.filename,
          fileSize: facture.blob.size,
        },
      };
      data["apiError"] = "";
      const serverResponse = (res) => {
        if (res.status !== 200) {
          console.error(
            "serverResponse onSubmitDB failed, status:",
            res.status,
          );
          throw new Error("sendOrder failed");
        }
      };

      await sendOrder(data, true, serverResponse);
      await sendInvoiceEmail({
        files: [
          {
            file: facture.base64,
            fileName: facture.filename,
            type: facture.type,
          },
          {
            file: transferAgreement.base64,
            fileName: transferAgreement.filename,
            type: transferAgreement.type,
          },
        ],
        formInformation: {
          contractNumber: this.state.formInformation.contractNumber,
        },
        customerInformation: {
          customerFirstName: this.state.customerInformation.customerFirstName,
          customerLastName: this.state.customerInformation.customerLastName,
        },
        dealerInvoiceEmail: this.state.customerInformation.dealerInvoiceEmail,
        dealerEmail:
          this.state.customerInformation.dealerEmail !==
          this.state.customerInformation.dealerInvoiceEmail
            ? this.state.customerInformation.dealerEmail
            : undefined,
        lang: this.state.params.lang,
      });
      downloadPDF(transferAgreement.blob, transferAgreement.filename);
    } catch (err) {
      console.error("completeTransferAgreementPDF Outer error:", err);
      await this.sendTransferAgreementFailed();
    } finally {
      this.switchFormState("completed");
    }
  };
  completeUpCareOrder = async () => {
    try {
      await this.state.hireAgreementPdfPromise;
      const hireAgreementBlob = new Blob([this.state.hireAgreementFile.file], {
        type: "application/pdf",
      });
      const hireAgreementBase64 = await blobToBase64(hireAgreementBlob);
      const facture = await this.generateFacturePdf();

      this.setState({
        factureFictive: {
          file: facture.blob,
          fileName: facture.filename,
          fileSize: facture.blob.size,
        },
      });

      try {
        const caseNo = this.state.formInformation.contractNumber;
        const country = this.props.params.lang.toLowerCase();
        const privacyNoticeBlob = await this.fetchConfidentialityPDF();
        const extraFiles = this.state.extraFiles || [];
        const extraFileDocuments = extraFiles.map((file) => ({
          file: file,
          fileName: file.fileName || file.name,
          documentType: 1,
          description: "Extra Document",
        }));

        const documents = [
          {
            file: hireAgreementBlob,
            fileName: this.state.hireAgreementFile.fileName,
            documentType: 1,
            description: "Hire Agreement",
          },
          {
            file: privacyNoticeBlob,
            fileName: "confidentiality_message.pdf",
            documentType: 1,
            description: "Privacy Notice",
          },
          ...extraFileDocuments,
        ];
        await uploadDocuments(documents, caseNo, country);

        console.log("All documents uploaded successfully");
      } catch (err) {
        console.error("Document upload failed:", err.message);
      }

      let data = {
        ...this.state,
        hireAgreementFile: {
          file: hireAgreementBlob,
          fileName: this.state.hireAgreementFile.fileName,
          fileSize: this.state.hireAgreementFile.fileSize,
        },
        factureFictive: {
          file: facture.blob,
          fileName: facture.filename,
          fileSize: facture.blob.size,
        },
      };
      data["apiError"] = "";
      const serverResponse = (res) => {
        if (res.status !== 200) {
          console.error("sendOrder failed, status:", res.status);
          throw new Error("sendOrder failed");
        }
      };

      await sendOrder(data, true, serverResponse);

      await sendHireAgreementEmail({
        contractNumber: this.state.formInformation.contractNumber,
        customerName: this.state.customerInformation.customerName,
        customerEmail: this.state.customerInformation.customerEmail,
        signatoryEmail:
          this.state.customerInformation.signatories?.signatory1
            ?.emailSignatory,
        pdfBase64: hireAgreementBase64,
        fileName: this.state.hireAgreementFile.fileName,
        lang: this.state.params.lang,
      });

      await sendInvoiceEmail({
        files: [
          {
            file: facture.base64,
            fileName: facture.filename,
            type: facture.type,
          },
        ],
        formInformation: {
          contractNumber: this.state.formInformation.contractNumber,
        },
        customerInformation: {
          customerName: this.state.customerInformation.customerName,
        },
        dealerInvoiceEmail: this.state.customerInformation.dealerInvoiceEmail,
        dealerEmail:
          this.state.customerInformation.dealerEmail !==
          this.state.customerInformation.dealerInvoiceEmail
            ? this.state.customerInformation.dealerEmail
            : undefined,
        lang: this.state.params.lang,
      });
    } catch (err) {
      console.error("completeUpCareOrder error:", err);
    } finally {
      this.switchFormState("completed");
    }
  };

  fetchConfidentialityPDF = async () => {
    const lang = this.props.params.lang.toLowerCase();
    const formType = this.props.params.formType.toLowerCase();
    const privacyNoticeCountriesMap = {
      leaseplus: ["uk"],
      upcare: ["uk", "se"],
    };
    try {
      if (privacyNoticeCountriesMap[formType].includes(lang)) {
        const pdfBytes = await GeneratePrivacyNoticePdf({
          params: this.props.params,
          customerInformation: this.state.customerInformation,
        });
        return new Blob([pdfBytes], { type: "application/pdf" });
      }
      const response = await fetch(
        configSource.ROOT +
          `getimage?company=hcs&country=${lang}&type=confidentiality_message.pdf`,
      );
      return response.blob();
    } catch (error) {
      console.error("Error fetching confidentiality PDF:", error);
      return new Blob([], { type: "application/pdf" });
    }
  };

  handleClosePopup = () => {
    this.setState({ openPopup: false });
  };

  getOldPortalLink = () => {
    const lang = this.props.params.lang.toLowerCase();
    const baseUrl = "https://release.d2t0pto0s2tfo1.amplifyapp.com/hcs/";
    const url = baseUrl + lang + "/leaseplus" || null;
    return this.state.params.formType.toLowerCase() === "leaseplus" &&
      (lang === "uk" || lang === "fr" || lang === "de")
      ? "https://release.d2t0pto0s2tfo1.amplifyapp.com/onboarding/" + lang
      : url;
  };

  handleConditionChange = async (condition) => {
    const { formType } = this.state.params;
    const { productsValues, labels } = this.state;
    const lang = this.state.params.lang.toLowerCase();

    const contractLengths = condition === "used" ? [24] : [36, 60];
    const defaultContractLength = contractLengths[contractLengths.length - 1];

    const updatedFormInformation = {
      ...this.state.formInformation,
      productCondition: condition,
      lifeOffer: condition === "used" ? "secondLife" : "firstLife",
      customContractNumber:
        condition === "used"
          ? this.state.formInformation.customContractNumber
          : "",
      contractLengths,
      contractLength: defaultContractLength,
      totalPrice: 0,
      totalMonthlyFee: 0,
      totalResidue: 0,
    };

    const updatedCustomerInformation = {
      ...this.state.customerInformation,
      repurchase:
        condition === "used"
          ? labels.dealer_repurchase
          : this.state.customerInformation.repurchase,
    };

    const defaultProductValues = {
      deliveryDate: null,
      productList: condition === "used" ? "productList2" : "productList1",
      name: null,
      quantity: 1,
      serial: [],
      price: 0,
      service: 0,
      purchasePrice: 0,
      installation: 0,
      residual: 10,
      residualPrice: 0,
      accessory: [null],
      accessoryPrice: [0],
      purchasePriceAccessory: [0],
      installationAccessory: [0],
      residualPriceAccessory: [0],
      residualPriceAccessorySum: 0,
      purchasePriceAccessorySum: 0,
      installationAccessorySum: 0,
      upCare: false,
      firstIncresedRent: 0,
      totalProductPrice: 0,
      finished: false,
      ownServiceIncludes: {
        storage: false,
        consumables: false,
        education: false,
        maintenance: false,
        repairs: true,
        other: false,
        noService: false,
      },
      manuallyModified: {
        installationModified: false,
      },
    };

    if (condition === "used" && formType === "leaseplus") {
      const products = await getProducts(lang, formType, 24);

      const resetProducts = {};
      Object.keys(productsValues).forEach((id) => {
        resetProducts[id] = { ...defaultProductValues };
      });

      this.setState(
        {
          products: products.map((product) => product.name),
          variables: {
            ...this.state.baseVariables,
            ...this.state.usedVariables,
          },
          formInformation: updatedFormInformation,
          customerInformation: updatedCustomerInformation,
          productsValues: resetProducts,
        },
        () => {
          this.updateTotalMonthlyFee();
        },
      );
    } else {
      const products = await getProducts(lang, formType, 60);

      const resetProducts = {};
      Object.keys(productsValues).forEach((id) => {
        resetProducts[id] = { ...defaultProductValues };
      });

      this.setState(
        {
          products: products.map((product) => product.name),
          variables: { ...this.state.baseVariables },
          formInformation: updatedFormInformation,
          customerInformation: updatedCustomerInformation,
          productsValues: resetProducts,
        },
        () => {
          this.updateTotalMonthlyFee();
        },
      );
    }
  };
  render() {
    if (!this.validateParams()) return <NotFound />;
    if (this.state.firstRender) return;

    const onBoarding =
      this.state.params.formType.toLowerCase() === "leaseplus" ||
      this.state.params.formType.toLowerCase() === "upcare";

    const disabled = !(
      (this.state.formInformation.quoteChecked &&
        !this.state.formInformation.orderChecked) ||
      (this.state.formInformation.orderChecked &&
        this.state.formInformation.idChecked &&
        (!this.state.formInformation.newDealerChecked ||
          this.state.newDealerInformation.verifyNewDealer) &&
        (!onBoarding ||
          this.state.formInformation.newDealerNotChecked ||
          this.state.formInformation.newDealerChecked)) ||
      configSource["DEBUG"]
    );

    let showQuote = true;
    const style_campaign = {
      color: "#003366",
      fontSize: "25px",
    };
    const style_campaign_extra = {
      color: "#003366",
      fontSize: "18px",
    };

    if (
      ["leaseplus", "upcare"].includes(
        this.state.params.formType.toLowerCase(),
      ) &&
      Object.keys(this.state.labels).length !== 0
    ) {
      if (
        this.state.customerInformation.repurchase === "" ||
        this.state.customerInformation.repurchaseKey === ""
      ) {
        let state = this.state;
        state.customerInformation.repurchase =
          this.state.labels.dealer_repurchase;
        state.customerInformation.repurchaseKey = "dealer";
        this.setState(state);
      }
    }
    return !this.state.isVerified ? (
      <Stack className="form-wrapper" direction="column" alignItems="center">
        {this.state.params.lang.toLowerCase() === "be" && (
          <Stack className="select-wrapper" alignItems="stretch">
            <div className="margin-top">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Language</InputLabel>
                <Select
                  labelId="be-language-label"
                  id="be-language"
                  value={this.state.beLanguage}
                  label="Language"
                  onChange={this.handleSelectChange}
                  style={{ width: "100% !important" }}
                >
                  <MenuItem value={"nl"}>Dutch</MenuItem>
                  <MenuItem value={"fr"}>French</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Stack>
        )}
        <div className="completedText padding-bot">
          <h1 className="less-margin-bot">
            {(() => {
              if (
                this.state.params.formType.toLowerCase() === "leaseplus" &&
                this.state.params.lang.toLowerCase() === "uk"
              ) {
                return this.state.labels.welcome_leaseplus;
              }

              if (this.state.params.formType.toLowerCase() === "upcare") {
                return this.state.labels.ceora_campaign_header;
              }

              return this.state.labels.welcome;
            })()}
            {/* // this.state.labels.welcome */}
          </h1>
          {/* <p>{this.state.labels.enter_password}</p> */}
        </div>

        <Stack
          direction="column-reverse"
          justifyContent="center"
          divider={<Divider orientation="horizontal" flexItem />}
          spacing={7}
        >
          <Stack direction="column" alignItems="center" spacing={5}>
            <img src={this.state.img} alt="Husqvarna" height="120px" />
            <Button
              variant="contained"
              sx={{
                minWidth: "100px",
                minHeight: "55px",
                mr: 0,
                backgroundColor: this.state.color,
                "&:hover": {
                  backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                },
              }}
              onClick={this.handleDealerButtonClick}
              // disabled={true}
            >
              {this.state.labels.husqvarna_login}
            </Button>
            {/* <FormHelperText
              sx={{
                width: "450px",
                "text-align": "center",
              }}
            >
              {this.state.labels.sso_down}
            </FormHelperText> */}
          </Stack>
          <Stack alignItems="stretch">
            <Stack className="header" direction="row">
              <TextField
                type={"password"}
                label="Password"
                id="password_input"
                variant="outlined"
                value={this.state.passwordInput}
                onChange={(e) => {
                  e.target.id = "password_input";
                  this.handleInput(e);
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    e.target.id = "password_check";
                    this.handleClick(e);
                  }
                }}
              />
              <Button
                sx={{
                  minWidth: "100px",
                  minHeight: "55px",
                  ml: 2,
                  backgroundColor: this.state.color,
                  "&:hover": {
                    backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                  },
                }}
                id="password_check"
                variant="contained"
                onClick={(e) => {
                  this.handleClick(e);
                }}
                startIcon={<LoginIcon />}
              >
                {this.state.labels.login}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    ) : (
      <Stack className="form-wrapper" alignItems="stretch">
        <div>
          {this.state.params.lang.toLowerCase() === "be" && (
            <div>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Language</InputLabel>
                <Select
                  labelId="be-language-label"
                  id="be-language"
                  value={this.state.beLanguage}
                  label="Language"
                  onChange={this.handleSelectChange}
                >
                  <MenuItem value={"nl"}>Dutch</MenuItem>
                  <MenuItem value={"fr"}>French</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}
          {this.state.formInformation.formState === "edit" &&
            this.state.params.formType.toLowerCase() === "leaseplus" &&
            (this.state.params.lang.toLowerCase() === "fr" ||
              this.state.params.lang.toLowerCase() === "nl") &&
            this.state.invoiceDidNotMatchModalOpen && (
              <InvoiceModal
                handleChange={this.handleInvoiceModalClose}
                invoiceDidNotMatch={this.state.invoiceDidNotMatchModalOpen}
                labels={this.state.labels}
              />
            )}
          {this.state.formInformation.formState === "campaign_closed" && (
            <div>
              <Header
                text={this.state.headerText?.text}
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
                page={1}
              />
              <div className="padding-bot-small box-wrapper margin-bot">
                <div className="titles-wrapp">
                  <h1 className="titles" style={{ marginLeft: "20px" }}>
                    {this.state.labels.ceora_campaign_header}
                  </h1>
                  <hr />
                </div>
                <div>
                  <p
                    className="information_links"
                    dangerouslySetInnerHTML={{
                      __html: this.state.labels.ceora_campaign_info,
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  padding: "40px",
                  maxWidth: "600px",
                  margin: "50px auto",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    marginBottom: "10px",
                    color: "#333",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.labels.ceora_campaign_closed}
                </Typography>
              </div>
            </div>
          )}
          {this.state.formInformation.formState === "edit" && (
            <div>
              <Header
                text={
                  this.state.params.formType.toLowerCase() === "upcare"
                    ? this.state.labels.headerUpcare
                    : this.state.labels.header1
                }
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
                page={1}
              />

              <div className="padding-bot-small box-wrapper margin-bot">
                <div className="titles-wrapp">
                  <h1 className="titles" style={{ marginLeft: "20px" }}>
                    {this.state.labels.ceora_campaign_header}
                  </h1>
                  <hr />
                </div>
                <div>
                  <p
                    className="information_links"
                    dangerouslySetInnerHTML={{
                      __html:
                        this.state.labels.ceora_campaign_info +
                        " " +
                        this.state.labels.ceora_campaign_info2,
                    }}
                  />
                </div>
              </div>

              {this.props.params.formType.toLowerCase() === "leaseplus" && (
                <Modal
                  open={this.state.modalOpen}
                  onClose={() => this.setState({ modalOpen: false })}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      bgcolor: "background.paper",
                      border: "2px solid #000",
                      boxShadow: 24,
                      p: 4,
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      id="simple-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      {this.state.labels.important_information ||
                        "Important Notice"}{" "}
                      {/* Add your header text here */}
                    </Typography>
                    <Typography id="simple-modal-description" sx={{ mt: 2 }}>
                      {this.state.labels.end_of_campaign1}
                    </Typography>
                    <Typography id="simple-modal-description" sx={{ mt: 2 }}>
                      {this.state.labels.end_of_campaign2}
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{
                        mt: 2,
                        backgroundColor: this.state.color,
                        "&:hover": {
                          backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                        },
                      }}
                      onClick={() => this.setState({ modalOpen: false })}
                    >
                      {this.state.labels.preview_form}
                    </Button>
                  </Box>
                </Modal>
              )}
              <div>
                <strong>
                  <span style={style_campaign}>
                    {this.state.labels.campaign_header}
                  </span>
                </strong>
              </div>
              <div>
                <strong>
                  <span style={style_campaign_extra}>
                    {this.state.labels.campaign_header_extra}
                  </span>
                </strong>
              </div>
              {this.state.labels.hcs_information !== "" &&
                this.state.labels?.hcs_information !== undefined && (
                  <div>
                    <Information
                      label={this.state.labels.hcs_information}
                      changeHandler={this.handleFormInformationChange}
                    ></Information>
                  </div>
                )}

              <div className="titles-wrapp">
                {this.state.params.formType.toLowerCase() === "leaseplus" ? (
                  <h1 className="titles">
                    {this.state.labels.basic_information}
                  </h1>
                ) : (
                  <h1 className="titles">{this.state.labels.main_products}</h1>
                )}
                <hr />
              </div>
              <div>
                {this.props.params.formType.toLowerCase() === "leaseplus" && (
                  <div style={{ marginTop: "-20px", marginBottom: "20px" }}>
                    <Tooltip
                      title={
                        <span style={{ fontSize: "12px" }}>
                          {this.state.labels.tooltip_product_condition}
                        </span>
                      }
                      placement="top"
                    >
                      <FormGroup
                        row
                        name="productCondition"
                        sx={{
                          width: "100%",
                          flexDirection: "row",
                          flexWrap: "nowrap",
                          gap: 1,
                          paddingTop: "10px",
                        }}
                      >
                        <FormControlLabel
                          label={this.state.labels.new_product}
                          control={
                            <Checkbox
                              checked={
                                this.state.formInformation.productCondition ===
                                "new"
                              }
                              onChange={() => {
                                this.handleConditionChange(
                                  "new",
                                  this.state.formInformation,
                                );
                              }}
                              sx={{
                                opacity: 0,
                                width: 0,
                                height: 0,
                                p: 0,
                                m: 0,
                              }}
                            />
                          }
                          sx={{
                            width: "180px",
                            minHeight: "50px",
                            boxSizing: "border-box",
                            m: 0,
                            px: 2,
                            py: 1,
                            border: `1px solid ${
                              this.state.formInformation.productCondition ===
                              "new"
                                ? this.state.color
                                : "#000000"
                            }`,
                            borderRadius: "4px",
                            backgroundColor:
                              this.state.formInformation.productCondition ===
                              "new"
                                ? this.state.color
                                : "transparent",
                            color:
                              this.state.formInformation.productCondition ===
                              "new"
                                ? "#ffffff"
                                : "#000000",
                            cursor: "pointer",
                            justifyContent: "center",
                            transition:
                              "background-color 0.2s ease, color 0.2s ease",
                            "& .MuiFormControlLabel-label": {
                              color: "inherit",
                              width: "100%",
                              textAlign: "center",
                              fontWeight: "bold",
                            },
                          }}
                        />

                        <FormControlLabel
                          label={this.state.labels.used_product}
                          control={
                            <Checkbox
                              checked={
                                this.state.formInformation.productCondition ===
                                "used"
                              }
                              onChange={() =>
                                this.handleConditionChange(
                                  "used",
                                  this.state.formInformation,
                                )
                              }
                              sx={{
                                opacity: 0,
                                width: 0,
                                height: 0,
                                p: 0,
                                m: 0,
                              }}
                            />
                          }
                          sx={{
                            width: "180px",
                            minHeight: "50px",
                            boxSizing: "border-box",
                            m: 0,
                            px: 2,
                            py: 1,
                            border: `1px solid ${
                              this.state.formInformation.productCondition ===
                              "used"
                                ? this.state.color
                                : "#000000"
                            }`,
                            borderRadius: "4px",
                            backgroundColor:
                              this.state.formInformation.productCondition ===
                              "used"
                                ? this.state.color
                                : "transparent",
                            color:
                              this.state.formInformation.productCondition ===
                              "used"
                                ? "#ffffff"
                                : "#000000",
                            cursor: "pointer",
                            justifyContent: "center",
                            transition:
                              "background-color 0.2s ease, color 0.2s ease",
                            "& .MuiFormControlLabel-label": {
                              color: "inherit",
                              width: "100%",
                              textAlign: "center",
                              fontWeight: "bold",
                            },
                          }}
                        />
                      </FormGroup>
                    </Tooltip>
                  </div>
                )}

                <FormControl fullWidth style={{ gap: "16px" }}>
                  <InputLabel id="contractLength-label">
                    {this.state.labels.contract_length}
                  </InputLabel>
                  <Select
                    labelId="contractLength-label"
                    id="contractLength-select"
                    value={this.state.formInformation.contractLength}
                    label={this.state.labels.contract_length}
                    onChange={this.changeContractLength}
                  >
                    {this.state.formInformation.contractLengths.map(
                      (length) => {
                        return (
                          <MenuItem key={length} value={length}>
                            {length.toString() + " " + this.state.labels.months}
                          </MenuItem>
                        );
                      },
                    )}
                  </Select>
                  <Tooltip
                    title={
                      <span style={{ fontSize: "12px" }}>
                        {/* {this.props.labels.tooltip_repurchase} */}
                      </span>
                    }
                    placement="top"
                  >
                    <TextField
                      style={{
                        display:
                          this.state.params.formType.toLowerCase() ===
                            "upcare" && "none",
                      }}
                      value={this.state.customerInformation.repurchase}
                      name={"repurchase"}
                      onChange={(event) => {
                        this.removeAccessoryProduct(
                          this.state.accesoryLocation,
                        );
                        let state = this.state;
                        state.customerInformation.repurchaseKey =
                          event.target.value;
                        state.customerInformation.repurchase =
                          event.target.value;
                        state.customerInformation.repurchaseKey =
                          event.target.value ===
                          this.state.labels.dealer_repurchase
                            ? "dealer"
                            : "husqvarna";
                        state.productsValues = {
                          product1: {
                            deliveryDate: null,
                            productList: "productList1",
                            name: null,
                            quantity: 1,
                            serial: [],
                            price: 0,
                            service: 0,
                            purchasePrice: 0,
                            installation: 0,
                            residual: 10,
                            residualPrice: 0,
                            accessory: [null],
                            accessoryPrice: [0],
                            purchasePriceAccessory: [0],
                            installationAccessory: [0],
                            residualPriceAccessory: [0],
                            residualPriceAccessorySum: 0,
                            purchasePriceAccessorySum: 0,
                            installationAccessorySum: 0,
                            upCare: false,
                            firstIncresedRent: 0,
                            totalProductPrice: 0,
                            finished: false,
                            ownServiceIncludes: {
                              storage: false,
                              consumables: false,
                              education: false,
                              maintenance: false,
                              repairs: true,
                              other: false,
                              noService: false,
                            },
                            manuallyModified: {
                              installationModified: false,
                            },
                          },
                        };

                        this.setState(state);
                      }}
                      select
                      label={this.state.labels.repurchase_label}
                      helperText={
                        this.state.formInformation.productCondition ===
                          "new" && (
                          <>
                            <b>{this.state.labels.repurchase_helper}</b>
                          </>
                        )
                      }
                    >
                      {(this.state.formInformation.productCondition === "used"
                        ? [this.state.labels.dealer_repurchase]
                        : [
                            this.state.labels.dealer_repurchase,
                            this.state.labels.hcs_repurchase,
                          ]
                      ).map((option) => {
                        return (
                          <MenuItem value={option} key={option} id="test">
                            {option}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Tooltip>
                  {this.state.params.formType.toLowerCase() === "leaseplus" &&
                    this.state.formInformation.productCondition === "used" && (
                      <Tooltip
                        title={
                          this.state.labels.tooltip_hcs_customContractnumber ||
                          "Please add the HCS contract number of the original Lease Plus agreement. It is in the format 10000XXXXX"
                        }
                        placement="top-start"
                      >
                        <TextField
                          onChange={(event) => {
                            const value = event.target.value;

                            this.setState((prevState) => ({
                              formInformation: {
                                ...prevState.formInformation,
                                customContractNumber: value,
                              },
                            }));
                          }}
                          InputProps={{
                            inputProps: { minLength: 1, maxLength: 10 },
                          }}
                          value={
                            this.state.formInformation.customContractNumber
                          }
                          required
                          className={
                            this.state.formInformation.showInvalid &&
                            !this.state.formInformation.customContractNumber
                              ? "invalid"
                              : ""
                          }
                          label={
                            this.state.labels.label_hcs_customContractnumber ||
                            "HCS contract number on original contract"
                          }
                        />
                      </Tooltip>
                    )}
                </FormControl>
              </div>
              {this.state.params.formType.toLowerCase() === "leaseplus" && (
                <div className="titles-wrapp" style={{ marginTop: "16px" }}>
                  <h1 className="titles">{this.state.labels.products}</h1>
                  <hr />
                </div>
              )}
              {Object.keys(this.state.productsValues).map((id) => {
                return this.generateProduct(id);
              })}
              <div className="padding-top row ">
                <Tooltip title={this.state.labels.tooltip_add_product || ""}>
                  <Button
                    sx={{
                      backgroundColor: this.state.color,
                      "&:hover": {
                        backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                      },
                    }}
                    onClick={() => {
                      this.addAnotherProduct();
                    }}
                    variant="contained"
                    startIcon={<AddCircleOutlineIcon />}
                  >
                    {this.state.labels.add_product}
                  </Button>
                </Tooltip>
                {Object.keys(this.state.productsValues).length > 1 && (
                  <div className="padding-left">
                    <Tooltip
                      title={this.state.labels.tooltip_remove_product || ""}
                    >
                      <Button
                        onClick={() => {
                          this.removeProduct();
                        }}
                        color="error"
                        variant="contained"
                        startIcon={<RemoveCircleOutlineIcon />}
                      >
                        {this.state.labels.remove_product}
                      </Button>
                    </Tooltip>
                  </div>
                )}
              </div>
              {this.state.params.formType.toLowerCase() === "leaseplus" && (
                <div className="padding-top">
                  <div className="titles-wrapp">
                    <h1 className="titles">
                      {this.state.labels.accessories_title_2}
                    </h1>
                    <hr />
                  </div>
                  <div style={{ paddingBottom: 1 + "em" }}>
                    {this.state.accessoriesVisible && (
                      <Grid container spacing={2} className="">
                        <Grid item xs={4}>
                          <InputText
                            id={this.props.id + "_AccessoriesName"}
                            defaultValue={this.state.labels.accessory}
                            label={this.state.labels.accessory}
                            changeHandler={() => {}}
                            InputProps={{
                              readOnly: true,
                            }}
                            sx={{ width: "100%" }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <InputNumber
                            label={this.state.labels.accessory_price1}
                            id={this.props.id + "_AccessoriesPrice"}
                            defaultValue={this.state.accessorySinglePrice}
                            endAdornment={this.state.labels.currency}
                            changeHandler={(value) => {
                              let state = this.state;
                              const formType =
                                state.params.formType.toLowerCase();

                              state.productsValues[
                                this.state.accesoryLocation
                              ].residualPrice = this.getAccessoryResidualPrice(
                                state.params.lang,
                              );
                              state.accessorySingleResidual =
                                this.getAccessoryResidualPrice(
                                  state.params.lang,
                                );
                              state.productsValues[
                                this.state.accesoryLocation
                              ].purchasePrice = value;
                              state.accessorySinglePrice = value;

                              const vatMultiplier =
                                formType === "leaseplus"
                                  ? this.state.variables.vat_rate
                                  : 1;
                              let t =
                                (1 +
                                  this.state.variables.function_interest /
                                    1200) **
                                this.state.formInformation.contractLength;
                              const annuityAccessory =
                                (value *
                                  t *
                                  (this.state.variables.function_interest /
                                    1200)) /
                                ((1 +
                                  (this.state.variables.function_interest /
                                    1200) *
                                    this.state.variables.payment) *
                                  (t - 1));
                              state.productsValues[
                                this.state.accesoryLocation
                              ].price = annuityAccessory * vatMultiplier;

                              this.setState(state);
                              this.updateTotalMonthlyFee();
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <InputNumber
                            label={this.state.labels.accessory_residual_price1}
                            id={this.props.id + "_AccessoriesResidualPrice"}
                            defaultValue={this.state.accessorySingleResidual}
                            endAdornment={this.state.labels.currency}
                            changeHandler={this.handleChange}
                            disabled
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <div className="row">
                      {!this.state.accessoriesVisible && (
                        <Button
                          sx={{
                            backgroundColor: "#273A60",
                          }}
                          onClick={() => {
                            let state = this.state;
                            state.accessoriesVisible = true;
                            state.accesoryLocation = `product${Object.keys(state.productsValues).length + 1}`;
                            console.log(
                              `product${Object.keys(state.productsValues).length + 1}`,
                            );
                            this.addAccessoryProduct(
                              Object.keys(state.productsValues).length + 1,
                            );
                            console.log(
                              "state.accesoryLocation",
                              state.accesoryLocation,
                            );

                            this.setState(state);
                          }}
                          variant="contained"
                          startIcon={<AddCircleOutlineIcon />}
                        >
                          {this.state.labels.add_accessory}
                        </Button>
                      )}
                      {this.state.accessoriesVisible && (
                        <div
                          style={{
                            marginTop: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <Tooltip
                            title={
                              this.state.labels.tooltip_remove_accessory || ""
                            }
                          >
                            <Button
                              onClick={() => {
                                let state = this.state;
                                this.removeAccessoryProduct(
                                  state.accesoryLocation,
                                );
                                this.setState(state);
                              }}
                              variant="contained"
                              color="error"
                              style={{ width: "300px" }}
                              startIcon={<RemoveCircleOutlineIcon />}
                            >
                              {this.state.labels.remove_accessory}
                            </Button>
                          </Tooltip>
                          <> {this.state.labels.accesory_text}</>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {(this.state.formInformation.customer === "Business" ||
                this.state.params.formType.toLowerCase() === "standard") && (
                <div className="padding-top">
                  <div className="titles-wrapp">
                    <div className="titles-container">
                      <h1 className="titles">
                        {this.state.params.formType.toLowerCase() === "upcare"
                          ? this.state.labels.accessories_title_2
                          : this.state.params.formType.toLowerCase() ===
                                "construction" ||
                              this.state.params.formType.toLowerCase() ===
                                "flexpro"
                            ? this.state.labels.accessories_title_construction
                            : this.state.params.formType.toLowerCase() ===
                                "standard"
                              ? this.state.labels.additional_cost_title
                              : "Inget av de"}
                      </h1>
                      <h2 className="titles vision-accessory-title">
                        {this.state.labels.vision_accessory_disclaimer}
                      </h2>
                    </div>
                    <h4 style={{ marginBottom: 0, marginTop: "10px" }}>
                      {this.state.labels.accessories_no_insurance}
                    </h4>
                    <hr />
                  </div>
                  <div className="accessories padding-bot">
                    {Object.keys(this.state.accessories).map((id) => {
                      return this.generateAccessories(id);
                    })}
                  </div>
                  <div className="row">
                    <Tooltip
                      title={this.state.labels.tooltip_add_accessory || ""}
                    >
                      <Button
                        sx={{
                          backgroundColor: this.state.color,
                          "&:hover": {
                            backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                          },
                        }}
                        onClick={() => {
                          this.addAccessories();
                        }}
                        variant="contained"
                        startIcon={<AddCircleOutlineIcon />}
                      >
                        {this.state.labels.add_accessory}
                      </Button>
                    </Tooltip>
                    {Object.keys(this.state.accessories).length > 0 && (
                      <div className="padding-left">
                        <Tooltip
                          title={
                            this.state.labels.tooltip_remove_accessory || ""
                          }
                        >
                          <Button
                            onClick={() => {
                              this.removeAccessories();
                            }}
                            variant="contained"
                            color="error"
                            startIcon={<RemoveCircleOutlineIcon />}
                          >
                            {this.state.labels.remove_accessory}
                          </Button>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="padding-top">
                <h1 className="titles">{this.state.labels.how_to_proceed}</h1>
                <hr />
                <Tooltip
                  title={
                    <span style={{ fontSize: "12px" }}>
                      {this.state.labels.tooltip_order_quote || ""}
                    </span>
                  }
                  placement="top"
                >
                  <FormGroup
                    sx={{ width: "50%", flexDirection: "row", gap: 1 }}
                  >
                    {showQuote && (
                      <FormControlLabel
                        className="quote_order"
                        control={
                          <Checkbox
                            id="quote_check"
                            checked={this.state.formInformation.quoteChecked}
                            onChange={this.handleChecked}
                            sx={{
                              opacity: 0,
                              width: 0,
                              height: 0,
                              p: 0,
                              m: 0,
                            }}
                          />
                        }
                        sx={{
                          width: "210px",
                          minHeight: "50px",
                          boxSizing: "border-box",
                          m: 0,
                          px: 2,
                          py: 1,
                          border: `1px solid ${
                            this.state.formInformation.quoteChecked
                              ? this.state.color
                              : "#000000"
                          }`,
                          borderRadius: "4px",
                          backgroundColor: this.state.formInformation
                            .quoteChecked
                            ? this.state.color
                            : "transparent",
                          color: this.state.formInformation.quoteChecked
                            ? "#ffffff"
                            : "#000000",
                          cursor: "pointer",
                          justifyContent: "center",
                          transition:
                            "background-color 0.2s ease, color 0.2s ease",
                          "& .MuiFormControlLabel-label": {
                            color: "inherit",
                            width: "100%",
                            textAlign: "center",
                            fontWeight: "bold",
                          },
                        }}
                        label={this.state.labels.quote_button}
                      />
                    )}
                    <FormControlLabel
                      className="quote_order"
                      control={
                        <Checkbox
                          id="order_check"
                          checked={this.state.formInformation.orderChecked}
                          onChange={this.handleChecked}
                          sx={{
                            opacity: 0,
                            width: 0,
                            height: 0,
                            p: 0,
                            m: 0,
                          }}
                        />
                      }
                      sx={{
                        width: "210px",
                        minHeight: "50px",
                        boxSizing: "border-box",
                        m: 0,
                        px: 2,
                        py: 1,
                        border: `1px solid ${
                          this.state.formInformation.orderChecked
                            ? this.state.color
                            : "#000000"
                        }`,
                        borderRadius: "4px",
                        backgroundColor: this.state.formInformation.orderChecked
                          ? this.state.color
                          : "transparent",
                        color: this.state.formInformation.orderChecked
                          ? "#ffffff"
                          : "#000000",
                        cursor: "pointer",
                        justifyContent: "center",
                        transition:
                          "background-color 0.2s ease, color 0.2s ease",
                        "& .MuiFormControlLabel-label": {
                          color: "inherit",
                          width: "100%",
                          textAlign: "center",
                          fontWeight: "bold",
                        },
                      }}
                      label={this.state.labels.order_button}
                    />
                  </FormGroup>
                </Tooltip>
              </div>
              <hr />
              {this.state.formInformation.orderChecked && onBoarding && (
                <>
                  <Modal
                    open={this.state.openPopup}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxWidth: 560,
                        maxHeight: "90vh",
                        overflowY: "auto",
                        bgcolor: "background.paper",
                        border: "3px solid #000",
                        boxShadow: 24,
                        p: 6,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        id="modal-modal-description"
                        sx={{
                          textAlign: "center",
                          fontSize: 30,
                        }}
                      >
                        {this.state.labels.important_information}
                      </Typography>
                      <Typography
                        id="modal-modal-description"
                        sx={{
                          mt: 2,
                          mb: 2,
                          p: 2,
                          textAlign: "center",
                          fontSize: 22,
                        }}
                      >
                        {this.state.params.formType.toLowerCase() ===
                          "leaseplus" &&
                        this.state.params.lang.toLowerCase() === "fr"
                          ? this.state.labels.not_able_to_use_portal2
                          : this.state.labels.not_able_to_use_portal}
                      </Typography>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            mt: 2,
                            backgroundColor: this.state.color,
                            "&:hover": {
                              backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                            },
                          }}
                          onClick={this.handleClosePopup}
                        >
                          {this.state.labels.go_back}
                        </Button>
                        <Link href={this.getOldPortalLink()}>
                          <Button
                            variant="contained"
                            sx={{
                              mt: 2,
                              backgroundColor: this.state.color,
                              "&:hover": {
                                backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                              },
                            }}
                          >
                            {this.state.params.formType.toLowerCase() ===
                              "leaseplus" &&
                            this.state.params.lang.toLowerCase() === "fr"
                              ? this.state.labels.old_portal_link2
                              : this.state.labels.old_portal_link}
                          </Button>
                        </Link>
                      </div>
                    </Box>
                  </Modal>
                  <div className="padding-onboarding-title">
                    <h1 className="titles-onboarding">
                      {this.state.labels.first_order}
                    </h1>
                    <div className="padding-checkbox">
                      <FormGroup row={true}>
                        <FormControlLabel
                          className="new_dealer"
                          control={
                            <Checkbox
                              id="new_dealer_yes"
                              checked={
                                this.state.formInformation.newDealerChecked
                              }
                              onChange={this.handleChecked}
                            />
                          }
                          label={this.state.labels.positive_answer}
                        />
                        <FormControlLabel
                          className="new_dealer"
                          control={
                            <Checkbox
                              id="new_dealer_no"
                              checked={
                                this.state.formInformation.newDealerNotChecked
                              }
                              onChange={this.handleChecked}
                            />
                          }
                          label={this.state.labels.negative_answer}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <hr />
                </>
              )}
              {this.state.formInformation.orderChecked && (
                <div className="padding-top">
                  <div className="titles-wrapp">
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <h1 className="titles">
                        {this.state.labels.customer_information_title}
                      </h1>
                      {this.state.params.formType.toLowerCase() ===
                        "leaseplus" &&
                        this.state.params.lang.toLowerCase() === "no" && (
                          <div
                            style={{
                              width: "100%",
                              margin: "0px 10px",
                              fontSize: "10px",

                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            Vær oppmerksom på at denne portalen kun gjelder
                            privatpersoner. Hvis kunden din er et selskap, et
                            enkeltmannsforetak eller en borettslagsforening, må
                            du bruke den andre portalen.
                          </div>
                        )}
                    </div>
                    <hr />
                  </div>
                  {this.state.formInformation.customer === "Business" ? (
                    <div>
                      {(this.state.params.formType.toLowerCase() ===
                        "flexpro" ||
                        this.state.params.formType.toLowerCase() ===
                          "upcare") && (
                        <div>
                          <CompanyType
                            customerInformation={this.state.customerInformation}
                            changeHandler={this.handleCustomerInfoChange}
                            labels={this.state?.labels}
                            extraFiles={
                              this.state.customerInformation.businessExtraFiles
                            }
                            formInformation={this.state.formInformation}
                            color={this.state.color}
                            formType={this.state.params.formType}
                            lang={this.state.params.lang}
                          />
                          <br />
                        </div>
                      )}
                      <CustomerInformationBusiness
                        changeHandler={this.handleCustomerInfoChange}
                        checkHandler={this.handleChecked}
                        customerInformation={this.state.customerInformation}
                        formInformation={this.state.formInformation}
                        labels={this.state?.labels}
                        addSignatory={this.addSignatory}
                        removeSignatory={this.removeSignatory}
                        extraFiles={this.state.extraFiles}
                        addExtraFiles={this.addExtraFiles}
                        removeExtraFiles={this.removeExtraFiles}
                        formType={this.state.params.formType.toLowerCase()}
                        params={this.state.params}
                        color={this.state.color}
                      />
                    </div>
                  ) : (
                    <div>
                      {socialSecurityNumberCountries.includes(
                        this.state.params.lang.toLowerCase(),
                      ) &&
                      this.state.formInformation.fillBySSN &&
                      (this.state.params.lang.toLowerCase() === "se" ||
                        this.state.params.lang.toLowerCase() === "no" ||
                        this.state.params.lang.toLowerCase() === "dk") ? (
                        <FillBySSN
                          changeHandler={this.handleCustomerInfoChange}
                          formInfoChange={this.handleFormInformationChange}
                          customerInformation={this.state.customerInformation}
                          formInformation={this.state.formInformation}
                          labels={this.state?.labels}
                          params={this.state.params}
                        />
                      ) : (
                        <CustomerInformationPrivate
                          changeHandler={this.handleCustomerInfoChange}
                          deliveryChangeHandler={
                            this.handleCustomerDeliveryInfoChange
                          }
                          customerInformation={this.state.customerInformation}
                          formInformation={this.state.formInformation}
                          labels={this.state?.labels}
                          params={this.state.params}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
              {this.state.formInformation.quoteChecked && (
                <div className="padding-top">
                  <div className="titles-wrapp">
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <h1 className="titles">
                        {this.state.labels.customer_information_title}
                      </h1>
                      {this.state.params.formType.toLowerCase() ===
                        "leaseplus" &&
                        this.state.params.lang.toLowerCase() === "no" && (
                          <div
                            style={{
                              width: "100%",
                              margin: "0px 10px",
                              fontSize: "10px",

                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            Vær oppmerksom på at denne portalen kun gjelder
                            privatpersoner. Hvis kunden din er et selskap, et
                            enkeltmannsforetak eller en borettslagsforening, må
                            du bruke den andre portalen.
                          </div>
                        )}
                    </div>
                    <hr />
                  </div>
                  <QuoteCustomerInformation
                    changeHandler={this.handleCustomerInfoChange}
                    customerInformation={this.state.customerInformation}
                    formInformation={this.state.formInformation}
                    labels={this.state?.labels}
                    params={this.state.params}
                    customerType={this.state.formInformation.customer}
                  />
                </div>
              )}
              {this.state.formInformation.orderChecked &&
              !this.state.formInformation.fillBySSN ? (
                <div className="padding-top">
                  <CustomerInformationIdentification
                    customerInformation={this.state.customerInformation}
                    formInformation={this.state.formInformation}
                    labels={this.state?.labels}
                    params={this.state.params}
                    extraFiles={this.state.extraFiles}
                    idSelectHandler={this.handleIdSelect}
                    pepSelectHandler={this.handlePepSelect}
                    addExtraFiles={this.addExtraFiles}
                    changeHandler={this.handleCustomerInfoChange}
                    removeExtraFiles={this.removeExtraFiles}
                    checkHandler={this.handleChecked}
                    formType={this.state.params.formType.toLowerCase()}
                    productsValues={this.state.productsValues}
                  />
                </div>
              ) : null}
              {this.state.formInformation.quoteChecked ||
              this.state.formInformation.orderChecked ? (
                <div className="padding-top">
                  <div className="titles-wrapp">
                    <h1 className="titles">
                      {this.state.labels.dealer_information}
                    </h1>
                    <hr />
                  </div>
                  <DealerInformation
                    changeHandler={this.handleCustomerInfoChange}
                    customerInformation={this.state.customerInformation}
                    formInformation={this.state.formInformation}
                    labels={this.state?.labels}
                    params={this.state.params}
                    checkHandler={this.handleChecked}
                  />
                </div>
              ) : null}
              {/* This section is moved up in form, left it commented out for now, should be removed after testing */}
              {/* {this.state.formInformation.orderChecked && onBoarding && (
                <>
                  <Modal
                    open={this.state.openPopup}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "25%",
                        bgcolor: "background.paper",
                        border: "3px solid #000",
                        boxShadow: 24,
                        p: 6,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        id="modal-modal-description"
                        sx={{ textAlign: "center", fontSize: 30 }}
                      >
                        {this.state.labels.important_information}
                      </Typography>
                      <Typography
                        id="modal-modal-description"
                        sx={{
                          mt: 2,
                          mb: 2,
                          p: 2,
                          textAlign: "center",
                          fontSize: 22,
                        }}
                      >
                        {this.state.labels.not_able_to_use_portal}
                      </Typography>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            mt: 2,
                            backgroundColor: "#273A60",
                            "&:hover": {
                              backgroundColor: darken("#273A60", 0.2),
                            },
                          }}
                          onClick={this.handleClosePopup}
                        >
                          {this.state.labels.go_back}
                        </Button>
                        <Link href={this.getOldPortalLink()}>
                          <Button
                            variant="contained"
                            sx={{
                              mt: 2,
                              backgroundColor: "#273A60",
                              "&:hover": {
                                backgroundColor: darken("#273A60", 0.2),
                              },
                            }}
                          >
                            {this.state.labels.old_portal_link}
                          </Button>
                        </Link>
                      </div>
                    </Box>
                  </Modal>
                  <div className="padding-onboarding-title">
                    <h1 className="titles-onboarding">
                      {this.state.labels.first_order}
                    </h1>
                    <div className="padding-checkbox">
                      <FormGroup row={true}>
                        <FormControlLabel
                          className="new_dealer"
                          control={
                            <Checkbox
                              id="new_dealer_yes"
                              checked={
                                this.state.formInformation.newDealerChecked
                              }
                              onChange={this.handleChecked}
                            />
                          }
                          label={this.state.labels.positive_answer}
                        />
                        <FormControlLabel
                          className="new_dealer"
                          control={
                            <Checkbox
                              id="new_dealer_no"
                              checked={
                                this.state.formInformation.newDealerNotChecked
                              }
                              onChange={this.handleChecked}
                            />
                          }
                          label={this.state.labels.negative_answer}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <hr />
                </>
              )} */}
              {this.state.formInformation.newDealerChecked && (
                <div className="padding-top-small">
                  <div className="titles-wrapp">
                    <h1 className="titles">
                      {this.state.labels.new_dealer_title}
                    </h1>
                    <hr />
                  </div>
                  <NewDealer
                    newDealer={this.state.newDealerInformation}
                    labels={this.state?.labels}
                    changeHandler={this.handleNewDealerInfoChange}
                    formInformation={this.state.formInformation}
                    checkHandler={this.handleChecked}
                    params={this.state.params}
                    addSignatory={this.addSignatory}
                    removeSignatory={this.removeSignatory}
                    payment={false}
                  />
                </div>
              )}
              {(this.state.params.formType.toLowerCase() === "upcare" ||
                this.state.params.formType.toLowerCase() === "flexpro" ||
                this.state.params.formType.toLowerCase() === "construction" ||
                this.state.params.formType.toLowerCase() === "leaseplus") &&
                this.state.formInformation.orderChecked && (
                  <div className="padding-top">
                    <div className="titles-wrapp">
                      <h1 className="titles">
                        {this.state.labels.extra_information}
                      </h1>
                      <hr />
                    </div>
                    <Information
                      label={this.state.labels.other}
                      extraInfo={this.state.formInformation.extraInfo}
                      changeHandler={this.handleFormInformationChange}
                    ></Information>
                  </div>
                )}
              {this.state.params.formType.toLowerCase() === "flexpro" ||
              this.state.params.formType.toLowerCase() === "construction" ? (
                <div className="padding-top totalValues">
                  <DisplayField
                    id="totalPrice"
                    value={(
                      this.state.formInformation.totalPrice -
                      this.state.formInformation.totalAccessoriesPrice
                    ).toString()}
                    label={this.state.labels.total_product_price}
                    currency={this.state.labels.currency}
                    sx={{
                      width:
                        this.state.params.lang.toLowerCase() === "at"
                          ? "25%"
                          : "33%",
                    }}
                  />
                  <DisplayField
                    id="totalAccessoriesPrice"
                    value={this.state.formInformation.totalAccessoriesPrice.toString()}
                    label={
                      this.state.labels.label_total_price +
                      " " +
                      (this.state.params.formType.toLowerCase() === "flexpro"
                        ? this.state.labels.accessories_title
                        : this.state.labels.accessories_title_construction)
                    }
                    currency={this.state.labels.currency}
                    sx={{
                      width:
                        this.state.params.lang.toLowerCase() === "at"
                          ? "25%"
                          : "33%",
                    }}
                  />
                  <DisplayField
                    id="totalMonthlyFee"
                    value={this.state.formInformation.totalResidue.toString()}
                    label={this.state.labels.total_residual_value}
                    currency={this.state.labels.currency}
                    sx={{
                      width:
                        this.state.params.lang.toLowerCase() === "at"
                          ? "25%"
                          : "33%",
                    }}
                  />
                  {this.state.params.lang.toLowerCase() === "at" && (
                    <DisplayField
                      id="totalMonthlyFee"
                      value={
                        this.state.formInformation.totalMonthlyFee *
                        (this.state.formInformation.contractLength + 1) *
                        0.01 *
                        1.2
                      }
                      label={this.state.labels.extra_fee}
                      currency={this.state.labels.currency}
                      sx={{ width: "25%" }}
                    />
                  )}
                </div>
              ) : null}
              <div className="padding-top padding-bot">
                <DisplayField
                  id="totalMonthlyFee"
                  value={roundTotalMonthlyFeeByCountry(
                    this.state.params.lang.toLowerCase(),
                    this.state.formInformation.totalMonthlyFee.toString(),
                    this.state.params.formType.toLowerCase(),
                  )}
                  label={
                    this.state.params.formType.toLowerCase() === "leaseplus"
                      ? this.state.labels.total_monthly_fee +
                        "" +
                        this.state.labels.inc_vat
                      : this.state.labels.total_monthly_fee
                  }
                  countryCode={this.state.params.lang.toLowerCase()}
                  formType={this.state.params.formType.toLowerCase()}
                  currency={this.state.labels.currency}
                />
              </div>
              <div className="campaign">
                {this.state.campaign && (
                  <>
                    <TextField
                      id={this.state.labels.campaign_description}
                      defaultValue={this.state.labels.campaign_description}
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormControlLabel
                      className="campaign"
                      control={
                        <Checkbox
                          id="campaign"
                          checked={this.state.formInformation.useCampaign}
                          onChange={() => {
                            let state = this.state;
                            state.formInformation.useCampaign =
                              !state.formInformation.useCampaign;
                            this.setState(state);
                          }}
                        />
                      }
                      label={this.state.labels.campaign_checkbox}
                    />
                  </>
                )}
              </div>
              <div className="button-container">
                <div className="button-container-row">
                  <Button
                    sx={{
                      minWidth: "350px",
                      minHeight: "45px",
                      backgroundColor: this.state.color,
                      "&:hover": {
                        backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                      },
                      marginLeft: "auto",
                    }}
                    onClick={async () => {
                      if (this.validateFormInputs()) {
                        if (
                          this.state.params.lang.toLowerCase() === "fr" &&
                          this.state.formInformation.orderChecked
                        ) {
                          this.setState({ openPopupDocs: true });
                        } else {
                          this.switchFormState("review");
                          this.setState({ isLoading: false });
                        }
                      }
                    }}
                    variant="contained"
                    disabled={disabled}
                  >
                    {this.state.isLoading ? (
                      <CircularProgress />
                    ) : (
                      <>
                        <ArrowForwardRoundedIcon sx={{ marginLeft: "300px" }} />
                        <span className="app-span-text">
                          {this.state.labels.preview_form}{" "}
                        </span>
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          )}

          <Modal
            open={this.state.openPopupDocs}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "35%",
                bgcolor: "background.paper",
                border: "3px solid #000",
                boxShadow: 24,
                p: 6,
                textAlign: "center",
              }}
            >
              <Typography
                id="modal-modal-description"
                sx={{ textAlign: "center", fontSize: 30 }}
              >
                Informations importantes!
              </Typography>
              <Typography sx={{ mt: 3, fontSize: 19, textAlign: "left" }}>
                Pour pouvoir passer votre commande, vous devez fournir les
                éléments suivants:
              </Typography>

              <Typography
                sx={{ mt: 1, fontSize: 18.5, textAlign: "left", pl: 2 }}
              >
                1. Facture d'électricité du client (au format PDF)
                <br />
                2. Coordonnées bancaires du client (pour les paiements
                automatiques)
              </Typography>

              <Typography sx={{ mt: 1, fontSize: 19, textAlign: "left" }}>
                Veuillez vous assurer que vous disposez de ces deux éléments
                avant de poursuivre.
              </Typography>

              <Typography
                sx={{
                  fontSize: 15,
                  mt: 1,
                  textAlign: "left",
                }}
              >
                (Si vous continuez sans ces deux éléments, vous devrez peut-être
                recommencer la procédure de commande et toutes les données
                saisies précédemment seront perdues)
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                  gap: "10px",
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    minWidth: "100px",
                    minHeight: "52px",
                    backgroundColor: "#273A60",
                  }}
                  onClick={() =>
                    this.setState({
                      openPopupDocs: false,
                    })
                  }
                >
                  {this.state.labels.go_back}
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    minWidth: "100px",
                    minHeight: "52px",
                    backgroundColor: this.state.color,
                    "&:hover": {
                      backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                    },
                  }}
                  onClick={() => {
                    this.setState({ openPopupDocs: false }, () => {
                      this.switchFormState("review");
                    });
                  }}
                >
                  {this.state.labels.preview_form}
                </Button>
              </div>
            </Box>
          </Modal>
          {this.state.openPopupAdyen && (
            <Modal
              open={this.state.openPopupAdyen}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "40%",
                  minWidth: "400px",
                  maxWidth: "600px",
                  bgcolor: "background.paper",
                  border: "3px solid #000",
                  boxShadow: 24,
                  p: 6,
                  textAlign: "center",
                }}
              >
                <Typography
                  id="modal-modal-description"
                  sx={{ textAlign: "center", fontSize: 30, color: "crimson" }}
                >
                  {this.state.popupHeaderMessage}
                </Typography>
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 2,
                    mb: 2,
                    p: 2,
                    textAlign: "left",
                    lineHeight: 1.6,
                    fontSize: 18,
                    whiteSpace: "pre-line",
                  }}
                >
                  {this.state.popupMessage}
                </Typography>

                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    minWidth: "100px",
                    minHeight: "52px",
                    backgroundColor: this.state.color,
                    "&:hover": {
                      backgroundColor: darken(this.state.color, 0.2),
                    },
                  }}
                  onClick={() => {
                    this.setState({ openPopupAdyen: false }, () => {
                      this.switchFormState("edit");
                    });
                  }}
                >
                  {this.state.labels.go_back}
                </Button>
              </Box>
            </Modal>
          )}

          {this.state.formInformation.formState === "review" && (
            <div>
              <Header
                text={
                  this.state.formInformation.orderChecked
                    ? this.state.labels.header2
                    : this.state.labels.header3
                }
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
                page={2}
              />

              <div className="padding-top">
                <FormRes
                  formInformation={this.state.formInformation}
                  productsValues={this.state.productsValues}
                  customerInformation={this.state.customerInformation}
                  labels={this.state.labels}
                  accessories={this.state.accessories}
                  extraFiles={this.state.extraFiles}
                  params={this.state.params}
                  pdf={false}
                  switchFormState={this.switchFormState}
                  products={this.state.products.productList1}
                  productAccessories={this.state.accessories}
                  variables={this.state.variables}
                  newDealerInformation={this.state.newDealerInformation}
                  changeContractLength={this.changeContractLength}
                  headerImgSrc={this.state.headerImgSrc}
                  createContractPDf={this.createContractPDf}
                  color={this.state.color}
                ></FormRes>
              </div>
            </div>
          )}
          {this.state.formInformation.formState ===
            "confidentiality_notice" && (
            <div>
              <Header
                text={this.state.labels.confidentiality_header}
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
              />
              <div className="padding-top">
                <ConfidentialityNotice
                  labels={this.state.labels}
                  params={this.state.params}
                  switchFormState={this.switchFormState}
                  customerInformation={this.state.customerInformation}
                  color={this.state.color}
                ></ConfidentialityNotice>
              </div>
            </div>
          )}
          {this.state.formInformation.formState === "credit_check" && (
            <div>
              <Header
                text={this.state.labels.credit_check_header}
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
              />
              <div className="padding-top">
                {this.state.params.lang.toLowerCase() === "fr" ? (
                  <>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ padding: "20px" }}
                    >
                      {
                        "Étant donné que le système est numérique, le processus de crédit est plus strict que d'habitude. Par conséquent, le crédit peut être refusé lors de la première étape et sera examiné manuellement par HCS."
                      }
                    </Typography>
                    <Modal
                      open={this.state.openPopup}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "25%",
                          bgcolor: "background.paper",
                          border: "3px solid #000",
                          boxShadow: 24,
                          p: 6,
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          id="modal-modal-description"
                          sx={{ textAlign: "center", fontSize: 30 }}
                        >
                          Informations importantes!
                        </Typography>
                        <Typography
                          id="modal-modal-description"
                          sx={{
                            mt: 2,
                            mb: 2,
                            p: 2,
                            textAlign: "center",
                            fontSize: 22,
                          }}
                        >
                          La copie de la carte d'identité n'est pas requise, il
                          faut uniquement charger une facture d'électricité ou
                          de téléphone.
                        </Typography>

                        <Button
                          variant="contained"
                          size="large"
                          sx={{
                            minWidth: "100px",
                            minHeight: "52px",
                            backgroundColor: this.state.color,
                          }}
                          onClick={this.handleClosePopup}
                        >
                          Je comprends
                        </Button>
                      </Box>
                    </Modal>
                    <InvoiceUploader
                      labels={this.state.labels}
                      params={this.state.params}
                      customerInformation={this.state.customerInformation}
                      switchFormState={this.switchFormState}
                      addExtraFiles={this.addExtraFiles}
                      sendToCRMInvoiceUploadFailed={
                        this.sendToCRMInvoiceUploadFailed
                      }
                    />
                  </>
                ) : (
                  <CreditCheck
                    formInformation={this.state.formInformation}
                    productsValues={this.state.productsValues}
                    customerInformation={this.state.customerInformation}
                    labels={this.state.labels}
                    accessories={this.state.accessories}
                    params={this.state.params}
                    switchFormState={this.switchFormState}
                    products={this.state.products.productList1}
                    productAccessories={this.state.products?.accessories}
                    variables={this.state.variables}
                    newDealerInformation={this.state.newDealerInformation}
                    changeHandlerCustomer={this.handleCustomerInfoChange}
                    changeHandlerForm={this.handleFormInformationChange}
                    changeHandlerCredit={this.handleCreditInfoChange}
                    changeHandlerContractFile={this.handleContractFileChange}
                    changeHandlerCreditFile={this.handleCreditFileChange}
                    createContractPDf={this.createContractPDf}
                    sendBeforeCerditCheck={this.sendBeforeCerditCheck}
                  ></CreditCheck>
                )}
              </div>
            </div>
          )}
          {this.state.formInformation.formState === "create_contract" && (
            <div>
              <Header
                text={this.state.labels.contract_header}
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
              />

              <div className="padding-top">
                <DisplayContract
                  creditFile={this.state.creditFile}
                  contractFile={this.state.contractFile}
                  labels={this.state.labels}
                  params={this.state.params}
                  switchFormState={this.switchFormState}
                  formInformation={this.state.formInformation}
                  productsValues={this.state.productsValues}
                  customerInformation={this.state.customerInformation}
                  accessories={this.state.accessories}
                  extraFiles={this.state.extraFiles}
                  products={this.state.products}
                  variables={this.state.variables}
                  newDealerInformation={this.state.newDealerInformation}
                  headerImgSrc={this.state.headerImgSrc}
                  sendContract={this.sendContract}
                  changeHandler={this.handleCustomerInfoChange}
                  createTransferAgreementPdf={this.createTransferAgreementPdf}
                  invoiceDidNotMatch={this.state.invoiceDidNotMatch}
                ></DisplayContract>
              </div>
            </div>
          )}
          {this.state.formInformation.formState === "transfer_agreement" && (
            <div>
              <Header
                text={this.state.labels.transfer_agreement_header}
                imageSrc={this.state.headerImgSrc}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
                params={this.state.params}
                switchFormState={this.switchFormState}
                customerInformation={this.state.customerInformation}
                productsValues={this.state.productsValues}
              />

              <div className="padding-top">
                <TransferAgreement
                  labels={this.state.labels}
                  params={this.state.params}
                  switchFormState={this.switchFormState}
                  productsValues={this.state.productsValues}
                  customerInformation={this.state.customerInformation}
                  accessories={this.state.accessories}
                  changeHandler={this.handleCustomerInfoChange}
                  formInformation={this.state.formInformation}
                  products={this.state.products}
                  headerImgSrc={this.state.headerImgSrc}
                  transferAgreementFile={this.state.transferAgreementFile}
                  completeTransferAgreementPDF={
                    this.completeTransferAgreementPDF
                  }
                />
              </div>
            </div>
          )}
          {this.state.formInformation.formState === "completed" && (
            <div>
              <Header
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth={"200px"}
                headerType={"header"}
                labels={this.state.labels}
              />
              <div className="completedText">
                <h1>{this.state.labels.thank_you}</h1>
                {this.state.formInformation.orderChecked && (
                  <>
                    <div>
                      <p>{this.state.labels.order_sent}</p>
                    </div>
                    <div className="order_info">
                      <p>{this.state.labels.order_info}</p>
                    </div>
                  </>
                )}
                {this.state.formInformation.quoteChecked && (
                  <div>
                    <p>{this.state.labels.quote_downloaded}</p>
                  </div>
                )}
                <Button
                  sx={{
                    backgroundColor: this.state.color,
                    "&:hover": {
                      backgroundColor: darken(this.state.color, 0.2), // Darken by 20%
                    },

                    color: "white", // Text color
                    padding: "8px 16px", // Padding for larger button
                    fontSize: "32px", // Increase font size for readability
                    marginTop:
                      this.props.params.lang === "fr" &&
                      this.state.formInformation.orderChecked
                        ? "-23px"
                        : "0px",
                  }}
                  onClick={async () => {
                    await fetch(
                      configSource.ROOT +
                        `getimage?company=hcs&country=${this.state.params.lang.toLowerCase()}&type=FAQ-new.pdf`,
                    ).then((res) => window.open(res.url));
                  }}
                  variant="contained"
                >
                  FAQ
                </Button>
              </div>
            </div>
          )}
          {this.state.formInformation.formState === "payment_info" && (
            <div>
              <Header
                text={
                  this.state.labels?.payment_information_header ||
                  "Default Header"
                }
                imageSrc={this.state.headerImgSrc}
                params={this.state.params}
                imageWidth="200px"
                headerType="header"
                labels={this.state.labels}
              />
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ padding: "20px" }}
              >
                {/* this.state.labels?.payment_information_disclaimer-- This label is too long, swagger wont accept it. Need to be separated in order to be implemented correctly */}
                {this.props.params.lang === "fr"
                  ? "En tant que locataire, il est de votre responsabilité de vous assurer que le mode de paiement enregistré auprès de HCS ou de notre fournisseur tiers, le cas échéant, est valide, non bloqué et que le compte associé, le cas échéant, a une couverture suffisante (c'est-à-dire que le compte associé a un solde / limite de retrait suffisant, le cas échéant) pour débiter les frais conformément à l'accord. Vous devez enregistrer un nouveau mode de paiement au plus tard à la fin du mois civil précédant le mois civil au cours duquel le mode de paiement enregistré cesse d'être valable. En cas de prélèvement infructueux, HCS ou notre fournisseur tiers peut tenter de débiter à nouveau le mode de paiement enregistré. Si les tentatives de prélèvement échouent à plusieurs reprises, si le mode de paiement enregistré est invalide ou si le compte associé au mode de paiement enregistré n'a pas une couverture suffisante pour débiter les frais conformément à l'accord pour une autre raison, HCS enverra une facture par courrier électronique. Les intérêts de retard sont facturés conformément aux conditions de l'accord. Veuillez noter que si la durée de location ne commence pas le premier jour du mois civil, les frais pour ce mois seront calculés en multipliant le montant spécifié dans l'accord par le quotient entre le nombre de jours restants dans le mois précédent et le nombre total de jours dans le mois (sur la base de 360/360), de sorte que le montant présenté lors de l'enregistrement du mode de paiement peut différer du montant spécifié dans l'accord. Les données bancaires seront enregistrées et stockées par HCS ou un fournisseur tiers conformément à la norme de sécurité internationale PCI DSS (Payment Card Industry Data Security Standard)."
                  : this.props.params.lang === "uk"
                    ? "As a tenant, it is your responsibility to ensure that the payment method registered with HCS or our third-party provider, if applicable, is valid, not blocked, and that the associated account, if applicable, has sufficient funds (i.e., the associated account has a sufficient balance/withdrawal limit, if applicable) to debit the charges in accordance with the agreement. You must register a new payment method by the end of the calendar month preceding the calendar month in which the registered payment method expires. In the event of an unsuccessful debit, HCS or our third-party provider may attempt to debit the registered payment method again. If debit attempts fail repeatedly, if the registered payment method is invalid, or if the account associated with the registered payment method does not have sufficient funds to debit the charges in accordance with the agreement for any other reason, HCS will send an invoice by email. Late payment interest will be charged in accordance with the terms of the agreement. Please note that if the rental period does not begin on the first day of the calendar month, the charges for that month will be calculated by multiplying the amount specified in the agreement by the quotient of the number of days remaining in the previous month divided by the total number of days in the current month (based on a 360/360 basis). Therefore, the amount displayed when registering your payment method may differ from the amount specified in the agreement. Bank details will be recorded and stored by HCS or a third-party provider in accordance with the international security standard PCI DSS (Payment Card Industry Data Security Standard)."
                    : this.props.params.lang === "se"
                      ? "Som hyrestagare ansvarar du för att den betalningsmetod som registrerats hos HCS eller vår tredjepartsleverantör är giltig, inte spärrad och att det tillhörande kontot har tillräckliga medel för att debitera avgifterna enligt avtalet. Du måste registrera en ny betalningsmetod senast vid utgången av kalendermånaden före den kalendermånad då den registrerade betalningsmetoden löper ut. Om en debitering misslyckas kan HCS eller vår tredjepartsleverantör göra ytterligare försök att debitera den registrerade betalningsmetoden. Om debiteringsförsöken upprepade gånger misslyckas, om den registrerade betalningsmetoden är ogiltig eller om kontot som är kopplat till den registrerade betalningsmetoden av någon annan anledning saknar tillräckliga medel för att debitera avgifterna enligt avtalet, kommer HCS att skicka en faktura via e-post. Dröjsmålsränta debiteras i enlighet med avtalsvillkoren. Observera att om hyresperioden inte börjar den första dagen i kalendermånaden kommer avgiften för den månaden att beräknas genom att multiplicera det belopp som anges i avtalet med kvoten av antalet återstående dagar i den aktuella månaden dividerat med det totala antalet dagar i den aktuella månaden (beräknat enligt 360/360-metoden). Därför kan det belopp som visas när du registrerar din betalningsmetod skilja sig från det belopp som anges i avtalet. Bankuppgifter kommer att registreras och lagras av HCS eller en tredjepartsleverantör i enlighet med den internationella säkerhetsstandarden PCI DSS (Payment Card Industry Data Security Standard)."
                      : "Als Mieter sind Sie dafür verantwortlich, dass die bei HCS oder gegebenenfalls unserem Drittanbieter hinterlegte Zahlungsmethode gültig und nicht gesperrt ist und dass das zugehörige Konto gegebenenfalls über ausreichend Guthaben (d. h. ein ausreichendes Guthaben/Abhebungslimit) verfügt, um die Gebühren gemäß Vertrag abzubuchen. Sie müssen bis zum Ende des Kalendermonats vor dem Ablaufmonat der aktuellen Zahlungsmethode eine neue Zahlungsmethode registrieren. Im Falle einer fehlgeschlagenen Abbuchung kann HCS oder unser Drittanbieter erneut versuchen, die hinterlegte Zahlungsmethode zu belasten. Sollten Abbuchungsversuche wiederholt fehlschlagen, die hinterlegte Zahlungsmethode ungültig sein oder das zugehörige Konto aus anderen Gründen nicht über ausreichend Guthaben verfügen, um die Gebühren gemäß Vertrag abzubuchen, erhalten Sie von HCS eine Rechnung per E-Mail. Verzugszinsen werden gemäß den Vertragsbedingungen berechnet. Bitte beachten Sie, dass die Gebühren für einen Monat berechnet werden, wenn der Mietzeitraum nicht am ersten Tag des Kalendermonats beginnt. Die Berechnung erfolgt, indem der im Vertrag angegebene Betrag mit dem Quotienten aus der Anzahl der verbleibenden Tage des Vormonats und der Gesamtzahl der Tage des aktuellen Monats (auf Basis von 360/360) multipliziert wird. Daher kann der bei der Registrierung Ihrer Zahlungsmethode angezeigte Betrag vom im Vertrag angegebenen Betrag abweichen. Ihre Bankdaten werden von HCS oder einem Drittanbieter gemäß dem internationalen Sicherheitsstandard PCI DSS (Payment Card Industry Data Security Standard) erfasst und gespeichert."}
              </Typography>
              <PaymentSelection
                labels={this.state.labels}
                paymentId={this.state.paymentId}
                params={this.state.params}
                setDirectDebitState={this.setDirectDebitState}
                switchFormState={this.switchFormState}
                sendToCRMManualPayment={this.sendToCRMManualPayment}
                completeUpCareOrder={this.completeUpCareOrder}
                color={this.state.color}
              />
            </div>
          )}

          <br></br>
        </div>
        {this.state.formInformation.orderChecked && (
          <div className="padding-top">
            <StepperComponent
              steps={this.state.stepLabels}
              activeStep={this.state.stepCounter}
              country={this.state.params.lang.toLowerCase()}
              formType={this.state.params.formType.toLowerCase()}
            ></StepperComponent>
          </div>
        )}
      </Stack>
    );
  }
}

export default withParams(Hcs);
